{
  "it-IT": "Italiano",
  "en-GB": "Inglese - English",
  "fr-FR": "Francese - Français",
  "de-DE": "Tedesco - Deutch",
  "es-ES": "Spagnolo - Español",
  "ca-ES": "Catalano - Català",
  "en-US": "Americano - American",
  "es-US": "Spagnolo (US)",
  "hi-IN": "Indiano",
  "id-ID": "Indonesiano",
  "ja-JP": "Giapponese",
  "ko-KR": "Koreano",
  "nl-NL": "Olandese",
  "pl-PL": "Polacco",
  "pt-BR": "Portoghese (BR)",
  "ru-RU": "Russo",
  "uk-UA": "Ucraino - Yкраїнська",
  "zh-CN": "Cinese",
  "zh-HK": "Cinese (HK)",
  "zh-TW": "Cinese (TW)",
  "ABOUT_BUILD": "Build",
  "ABOUT_EXPIRY": "Il tuo abbonamento scadrà il",
  "ABOUT_PLAN": "Piano di abbonamento:",
  "ABOUT_TITLE": "Info",
  "ABOUT_VERSION": "Versione",
  "ACCESS-ADMIN-EMAIL": "Mail amministratore",
  "ACCESS-ADMIN-NAME": "Nome amministratore",
  "ACCESS-ADMIN-NOTES": "Note amministratore",
  "ACCESSCONFIG_ADMIN": "Amministratore",
  "ACCESSCONFIG_BUY": "Acquisto",
  "ACCESSCONFIG_BUY_AI_CREDITS": "Acquista crediti AI",
  "ACCESS_CONFIG": "Configura abbonamenti",
  "ACCESSCONFIG_BUY_SUBSCRIPTION_TITLE": "Sei un privato?",
  "ACCESSCONFIG_BUY_SUBSCRIPTION": "Acquista",
  "ACCESSCONFIG_CANCEL": "Annulla",
  "ACCESSCONFIG_CREATEDBY": "Creato da",
  "ACCESSCONFIG_CREATIONDATE": "Data di creazione",
  "ACCESSCONFIG_CREDITS_AI": "Crediti AI",
  "ACCESSCONFIG_CREDITS_AI_WAIT": "Attendi...",
  "ACCESSCONFIG_DELETE_SUBSCRIPTION": "Elimina abbonamento",
  "ACCESSCONFIG_DETAILS": "Configura",
  "ACCESSCONFIG_DISCOVER_TITLE": "Sei una scuola?",
  "ACCESSCONFIG_DISCOVER": "Scopri l'offerta",
  "ACCESSCONFIG_DOMAIN_DESC": "Tutti gli utenti con un account del dominio specificato potranno accedere a SMX studio.",
  "ACCESSCONFIG_DOMAIN": "Dominio",
  "ACCESSCONFIG_DOMAINLICS_DESC": "Indica il numero massimo di utenze ammesse per il dominio specificato. Inserire 0 per utenze illimitate.",
  "ACCESSCONFIG_DOMAINLICS": "Numero utenze del dominio",
  "ACCESSCONFIG_DOMAIN_PLACEHOLDER": "Dominio da abilitare",
  "ACCESSCONFIG_ERROR_CREDITS": "Errore nella gestione dei crediti",
  "ACCESSCONFIG_EXPIREDATE": "Scadenza",
  "ACCESSCONFIG_EXPIRE_DATE_DESC": "Indica la data di scadenza dell'abbonamento",
  "ACCESSCONFIG_HISTORY": "Storico ordini",
  "ACCESSCONFIG_INSERT_DOMAIN": "Aggiungi dominio",
  "ACCESSCONFIG_INSERT_GROUP": "Aggiungi gruppo di account",
  "ACCESSCONFIG_INSERT_SINGLE": "Aggiungi singolo utente",
  "ACCESSCONFIG_LASTMODIFICATIONBY": "Ordine modificato da",
  "ACCESSCONFIG_LASTMODIFICATIONDATE": "Ultima modifica ordine",
  "ACCESSCONFIG_LICENSE_DOMAIN": "Dominio",
  "ACCESSCONFIG_LICENSE_LICENSE": "licenze",
  "ACCESSCONFIG_LICENSE_MULTI": "Multipla",
  "ACCESSCONFIG_LICENSE_SINGLE": "Singola",
  "ACCESSCONFIG_LICENSETYPE": "Licenza",
  "ACCESSCONFIG_LIMITED_LICENSES": "(%s account)",
  "ACCESSCONFIG_LOCKED": "Stato contratto",
  "ACCESSCONFIG_LOCKED_TRUE": "In attesa di accettazione",
  "ACCESSCONFIG_LOCKED_FALSE": "Accettato",
  "ACCESSCONFIG_LOCKED_ACCEPTED": "Data di accettazione",
  "ACCESSCONFIG_MECHCODE": "Codice meccanografico",
  "ACCESSCONFIG_MECHCODE_PLACEHOLDER": "XXYY123456",
  "INVALID_MECHCODE_FORMAT": "Codice meccanografico non valido",
  "ACCESSCONFIG_MODIFY-ORDER": "Modifica/Rinnova manualmente",
  "ACCESSCONFIG_MSG_DELETE_FAIL": "ERRORE nella cancellazione dell'abbonamento!",
  "ACCESSCONFIG_MSG_DELETE_OK": "L'abbonamento è stato cancellato.",
  "ACCESSCONFIG_MSG": "Gestisci gli indirizzi email associati a SMX studio",
  "ACCESSCONFIG_MSG_SAVE_FAIL": "Errore nel salvataggio della lista abbonamenti.",
  "ACCESSCONFIG_MSG_SAVE_FAIL_ACCEPT": "Errore nel salvataggio dell'accettazione del contratto.",
  "ACCESSCONFIG_MSG_SAVE_SUCCESS": "Il salvataggio della lista abbonamenti è avvenuto correttamente.",
  "ACCESSCONFIG_MSG_SINGLE": "Gestisci l'indirizzo email associato a SMX studio",
  "ACCESSCONFIG_NAME_DESC": "Inserisci qui un nome per identificare la configurazione. Questo nome servirà per distinguere le configurazioni in caso di più abbonamenti.",
  "ACCESSCONFIG_NAME": "Nome abbonamento",
  "ACCESSCONFIG_NAME_PLACEHOLDER": "es. Classe 2A o Doposcuola di Marco",
  "ACCESSCONFIG_OCR_QUOTA": "OCR matematico - quota",
  "ACCESSCONFIG_OCR_POLICY": "Conteggio OCR",
  "ACCESSCONFIG_OPENSTATS": "Statistiche",
  "ACCESSCONFIG_OPERATORS": "Operatori",
  "ACCESSCONFIG_ORDER_ACTIVE": "ATTIVO",
  "ACCESSCONFIG_ORDER_EXPIRED": "SCADUTO",
  "ACCESSCONFIG_ORDERID": "ID chiave",
  "ACCESSCONFIG_ORDER_STATUS": "Stato",
  "ACCESSCONFIG_ORDER_SUSPENDED": "SOSPESO",
  "ACCESSCONFIG_ORIGIN": "Origine",
  "ACCESSCONFIG_PLAN": "Piano",
  "ACCESSCONFIG_PRICE": "Prezzo",
  "ACCESSCONFIG_PRICE_NA": "Non disponibile",
  "ACCESSCONFIG_REFORDERID": "Riferimento ordine",
  "ACCESSCONFIG_RENEW_INVALID_ORDER": "L'ordine da rinnovare non è valido. Contattare l'assistenza.",
  "ACCESSCONFIG_RENEW_SUBSCRIPTION": "Rinnova abbonamento",
  "ACCESSCONFIG_RESET": "Annulla modifiche",
  "ACCESSCONFIG_SAVE": "Salva",
  "ACCESSCONFIG_RESEND_EMAIL": "Reinvia email",
  "ACCESSCONFIG_SENDADMINEMAIL_ACTIVATION": "Manda email attivazione all'amministratore",
  "ACCESSCONFIG_SENDADMINEMAIL_RENEW": "Manda email di rinnovo all'amministratore",
  "ACCESSCONFIG_SENDEMAIL_ACTIVATION": "Manda email attivazione all'acquirente",
  "ACCESSCONFIG_SENDEMAIL_RENEW": "Manda email di rinnovo all'acquirente",
  "ACCESSCONFIG_SLOTS": "Numero di utenti",
  "ACCESSCONFIG_TITLE": "Configura abbonamento",
  "ACCESSCONFIG_GO_HOME": "Vai a SMXstudio",
  "ACCESSCONFIG_UNLIMITED_LICENSES": "(account illimitati)",
  "ACCESSCONFIG_UNLOCK": "Accetto il contratto",
  "ACCESSCONFIG_UPDATE_ORDER": "Modifica ordine",
  "ACCESSCONFIG_USERADMIN": "Amministratore",
  "ACCESSCONFIG_PUBLIC": "Visilibità utenti",
  "ACCESSCONFIG_PUBLIC_DESC": "Durante la condivisione dei documenti permette di visualizzare e scegliere l'email tra gli utenti inclusi nell'abbonamento.",
  "TBD_OPTION_1": "Nuovo abbonamento",
  "TBD_OPTION_2": "Rinnovo di un abbonamento esistente",
  "TBD_OPTION_3": "Rinnova demo",
  "TBD_CONFIRM": "Conferma selezione",
  "ACCESSCONFIG_USERADMIN_DESC": "L'account email che ha in gestione l'abbonamento e che può configurarne i permessi di accesso.",
  "ACCESSCONFIG_USERADMIN_DESC_SINGLE": "L'account email che ha in gestione l'abbonamento e che può accedere a SMX studio.",
  "ACCESSCONFIG_USERADMIN_PLACEHOLDER": "Email amministratore",
  "ACCESSCONFIG_USERADMIN_SINGLE": "Email",
  "ACCESSCONFIG_USER_NAME": "Acquirente",
  "ACCESSCONFIG_USER_NAME_PLACEHOLDER": "Nome dell'acquirente",
  "ACCESSCONFIG_USERS": "Numero di utenti",
  "ACCESSCONFIG_EXTRA_USERS": "Numero di utenti extra dominio",
  "ACCESSCONFIG_USERS_DESC": "Lista degli indirizzi email che possono accedere a SMX studio.",
  "ACCESSCONFIG_USERS_DESC_NODOMAIN": "Lista degli indirizzi email che possono accedere a SMX studio non compresi nel dominio inserito.",
  "ACCESSCONFIG_USERS_NAME_PLACEHOLDER": "Nome",
  "ACCESSCONFIG_USERS_NOTE_PLACEHOLDER": "Note",
  "ACCESSCONFIG_USERS_PLACEHOLDER": "Email",
  "ACCESSCONFIG_USERS_WARNING": "ATTENZIONE: devono essere tutti account email Google",
  "ACCESSCONFIG_BACK": "Indietro",
  "ACCESSCONFIG_REFRESH": "Aggiorna la pagina",
  "ACCESSCONFIG_GO_SMX": "Vai a SMXstudio",
  "ACCESS-DOMAIN": "Nome dominio",
  "ACCESS-NAME": "Nome accesso",
  "ACCESS-USERS-EMAIL": "Mail utente #",
  "ACCESS-USERS-NAME": "Nome utente #",
  "ACCESS-USERS-NOTES": "Note utente #",
  "ADD": "Aggiungi",
  "ADMIN_NAME": "Nome della configurazione",
  "ADMIN_TITLE": "Configura abbonamenti",
  "ADMIN_STATS_TITLE": "Statistiche generali",
  "ALIGNMENT_TOOLBAR-ALIGN": "Allinea",
  "ALIGNMENT_TOOLBAR-BOTTOM": "Basso",
  "ALIGNMENT_TOOLBAR-CENTER": "Centro",
  "ALIGNMENT_TOOLBAR-LEFT": "Sinistra",
  "ALIGNMENT_TOOLBAR-RIGHT": "Destra",
  "ALIGNMENT_TOOLBAR-TOP": "Alto",
  "ALLSAVED": "Tutte le modifiche sono salvate",
  "APP_NAME": "SMX studio",
  "ARRANGE_BASE": "L'intera mappa sarà riorganizzata come albero dall'alto.",
  "ARRANGE_WARNING_START": "ATTENZIONE: La mappa contiene una o più di queste caratteristiche:",
  "ARRANGE_WARNING_LOCKED": " • Nodi bloccati che non saranno spostati",
  "ARRANGE_WARNING_CURVES": " • Frecce curve che verranno raddrizzate",
  "ARRANGE_WARNING_PAIRS": " • Relazioni paritarie che potrebbero rendere la mappa non interpretabile in modo automatico",
  "ARRANGE_WARNING_END": "L'utilizzo del comando potrebbe generare una mappa da sistemare manualmente.",
  "ARRANGE_CONFIRM": "Confermi?",
  "ASK_CLEAR_CHAT": "Cancellare la chat? I messaggi non potranno più essere recuperati.",
  "ATTACHMENT": "Allegato",
  "BACK_TO_LOGIN": "Torna al login",
  "BUTTON_CLOSE": "Chiudi",
  "BUTTON_NO": "No",
  "BUTTON_OK": "Ok",
  "BUTTON_YES": "Sì",
  "CANCEL": "Annulla",
  "CAPTURE_CAMERA": "Cattura",
  "CHAT_CLEAR": "Cancella chat",
  "CHAT_MESSAGES_UNREAD": "MESSAGGI NON LETTI",
  "CHAT_SEND": "Invia messaggio",
  "CHAT_TODAY": "Oggi",
  "CHAT_YESTERDAY": "Ieri",
  "CONFIG_SUBSCRIPTIONS": "Gestione abbonamenti",
  "COPY": "Copia",
  "COPY_LINK": "COPIA",
  "COPY_MAP": "Crea una copia",
  "COPY_MAP_FOR_EDIT": "Crea una copia per modificarla",
  "COPYOF": "Copia di ",
  "COPY_PASTE_INFO1": "Copia e incolla in SMX studio",
  "COPY_PASTE_INFO2": "Queste azioni non sono disponibili dal menu Modifica, ma puoi sempre usare:",
  "COPY_PASTE_INFO3_C": "per copiare",
  "COPY_PASTE_INFO3_V": "per incollare",
  "COPY_PASTE_INFO3_X": "per tagliare",
  "COPY_SHOW": "VISUALIZZA",
  "CREATE_GOOGLE_DOC": "Crea documento Google",
  "CREATE_MAP_ERROR": "Errore nella creazione della mappa",
  "CREATE_RECENT_COPY": "Crea una copia",
  "CREATING_COPY": "Sto creando una copia",
  "CURRENT_PAGE": "Pagina",
  "CUSTOM": "Personalizzabile",
  "DATE_NOTIFICATION": "Data",
  "DEEPTEXT": "Approfondimento",
  "DEEP_OPEN_MODIFY": "Modifica approfondimento",
  "DEEP_CLOSE_MODIFY": "Chiudi modifica",
  "DELETE_CONFIRM": "Vuoi veramente cancellare l'ordine '§orderId§'?",
  "DELETE_DEEPTEXT": "Approfondimento",
  "DELETE_EDGE": "Freccia",
  "DELETE": "Elimina",
  "DELETE_IMAGE": "Immagine",
  "DELETE_LINK": "Link",
  "DELETE_NODE": "Nodo",
  "DELETE_TEXT": "Testo",
  "DELETE_VIDEO": "Video",
  "DEMO_REQUEST_1": "Stai richiedendo un periodo dimostrativo di 30 giorni, durante i quali avrai accesso a tutte le funzionalità di SMX studio.",
  "DEMO_REQUEST_2": "Al termine del periodo dimostrativo nell'area [Gestisci abbonamento] potrai acquistare un abbonamento e proseguire l'utilizzo ritrovando tutte le tue mappe create.",
  "DEMO_REQUEST_3A": "Per attivare il periodo dimostrativo premi il bottone",
  "DEMO_REQUEST_3B": "e fai login con l'utente che desideri attivare.",
  "DEMO_REQUEST_4": "Nota bene: l'account deve essere una mail di Google valida.",
  "DEMO_REQUEST_BUTTON": "Provalo per 30 giorni",
  "DESC_APP": "Mappe concettuali per l'apprendimento.",
  "DIRTY": "Ci sono delle modifiche non salvate",
  "EXIT_CONFIRM": "Confermi l'uscita?",
  "DOC_AUTHOR": "Autore",
  "DOC_CREDITS": "Realizzato con SMX studio - Anastasis",
  "DOC_MAP_IMAGES": "Immagini della mappa",
  "DOC_NOTES": "Appunti",
  "DOWNLOAD_CHROME2": "è richiesto il browser gratuito Google Chrome",
  "DOWNLOAD_CHROME": "Per usare SMX studio",
  "DOWNLOAD_RECENT": "Scarica",
  "DRIVE_USAGE": "Utilizzo di Google Drive",
  "EDIT_IMAGE": "Modifica immagine",
  "EDIT_MODE": "Modifica",
  "EDIT_NODE_TITLE": "Titolo nodo",
  "EDIT_NOTIFICATION": "Modifica",
  "EDIT_TEXT": "Modifica testo",
  "EMAIL_ALREADY_EXISTS_MSG": " è gia stato inserito nella lista degli abbonamenti.",
  "EMPTY_NAME_NOT_ALLOWED": "Il nome della configurazione non può essere vuoto",
  "ERR_ACCESS_DENIED": "Occorre accettare tutti gli ambiti per poter proseguire",
  "ERR_EARLY_START": "Il tuo account sarà attivo dal giorno",
  "ERR_GDRIVE_3PTY_DISABLED": "L'amministratore del tuo dominio ha disabilitato le app di terze parti",
  "ERR_LOCKED": "Questa utenza è momentaneamente bloccata.<br />Potrai accedere dopo che il tuo amministratore avrà accettato i termini del contratto.",
  "ERR_LOGIN_BACK_TO_LOGIN": "Riprova ad entrare",
  "ERR_LOGIN_DOUBLE_ACCESS": "Il tuo account è in uso su un altro dispositivo",
  "ERR_LOGIN_MIXED": "Devi selezionare lo stesso utente in entrambe le finestre di accesso",
  "ERR_LOGIN_INVALID_CREDENTIALS": "Le credenziali fornite non sono valide",
  "ERR_LOGIN_SESSION_EXPIRED": "La sessione è scaduta",
  "ERR_TOKEN_EXPIRED": "Autorizza SMX studio ad usare Google",
  "ERR_LOGIN_NOT_VALID_SCOPES": "Occorre accettare tutti gli ambiti per poter proseguire",
  "ERR_LOGIN_GOOGLE": "Errore nel login di Google",
  "ERROR_AUTHENTICATION": "Errore di autenticazione",
  "ERROR_CONVERTDATAURL": "Errore interno al server",
  "ERROR_DATABASE": "Errore nell'accesso al Database",
  "ERROR_GENERATESME": "Errore nella generazione della mappa",
  "ERROR_GETPROTOCOL": "Errore interno al server",
  "ERROR_GOOGLEDRIVE": "Errore nell'accesso a Google Drive",
  "ERROR_GOOGLEID_NOT_FOUND": "Questo documento non esiste o non è più condiviso",
  "ERROR_GRAPHML2JSON": "Errore nel caricamento della mappa",
  "ERROR_INSERT_IMAGE": "Immagine non valida",
  "ERROR_INVALID_CREDENTIALS": "Accesso a Google Drive non riuscito. Esci da SMX studio e fai nuovamente login per risolvere il problema.",
  "ERROR_LINK_PREVIEW": "Errore nell'anteprima del link",
  "ERROR_MAP_FORMAT_NOT_SUPPORTED": "File non supportato",
  "ERROR_MAPJSONEMPTY": "Errore nel formato della mappa",
  "ERROR_DOC_NOT_FOUND": "Mappa non trovata",
  "ERROR_MAP_NOT_SHARED": "Questa mappa non è condivisa",
  "ERROR_OPEN_MAP": "Errore durante l'apertura della mappa",
  "ERROR_OPENMAP": "Mappa non trovata",
  "ERROR_OWNER_NOT_FOUND": "Questa mappa non esiste o non è più condivisa",
  "ERROR_READFILE": "Errore nella lettura della mappa",
  "ERROR_RESIZEPNG": "Errore interno al server",
  "ERROR-SAVING": "Ooops! Non sono riuscito a salvare...",
  "ERROR_SENDMAIL": "Errore nell'invio della mail all'utente",
  "ERROR_STORAGE_DOWNLOAD": "Errore nell'accesso ai dati",
  "ERROR_UNSUPPORTEDPROTOCOL": "Errore interno al server",
  "ERROR_UNZIPMAP": "Errore nel caricamento della mappa",
  "ERROR_WRITEFILE": "Errore nella scrittura della mappa",
  "ERROR_WRITEJSON": "Errore nella scrittura della mappa",
  "ERROR_WRONGFILETYPE": "Il file deve essere .sme",
  "ERROR_WRONG_FILETYPE": "Il file non è una mappa .sme valida",
  "ERROR_ZIPPER": "Errore nel salvataggio della mappa",
  "EXIT": "Esci",
  "EXIT_MESSAGE": "Le modifiche apportate potrebbero non essere salvate.",
  "EXPIRE_DATE": "Data di scadenza",
  "EXP_WARNING_ACCOUNT_EXPIRED_DATE": "Il tuo abbonamento è scaduto in data",
  "EXP_WARNING_ACCOUNT_EXPIRED": "Il tuo abbonamento è scaduto",
  "EXP_WARNING_DEMO_EXPIRED_DATE": "Il tuo dimostrativo è scaduto in data",
  "EXP_WARNING_DEMO_EXPIRED": "Il tuo dimostrativo è scaduto",
  "EXP_WARNING_ACCOUNT_EXPIRING_DATE": "L'abbonamento scadrà in data",
  "EXP_WARNING_BUY": "Acquista abbonamento",
  "EXP_WARNING_DEMO_EXPIRING_DATE": "Il dimostrativo scadrà in data",
  "EXP_WARNING_READONLY": "Puoi continuare a vedere le mappe in sola lettura.",
  "EXP_WARNING_RENEW_REFERRER": "Per rinnovare il tuo abbonamento contatta il tuo referente.",
  "EXP_WARNING_RENEW": "Rinnova abbonamento",
  "FIELD_REQUIRED": "Campo obbligatorio",
  "FIRST_PAGE_LABEL": "Prima pagina",
  "FLIP_HOR": "Specchia orizzontalmente",
  "FLIP_VERT": "Specchia verticalmente",
  "FORBIDDEN": "Non puoi accedere alla risorsa",
  "FORMAT_COPY_FORMAT": "Copia formato",
  "FORMAT_NODE_TOOLBAR-ARROW-LEFT": "Freccia indietro",
  "FORMAT_NODE_TOOLBAR-ARROW-RIGHT": "Freccia avanti",
  "FORMAT_NODE_TOOLBAR-BACKGROUND-COLOR": "Colore sfondo nodo",
  "FORMAT_NODE_TOOLBAR-BOLD": "Grassetto",
  "FORMAT_NODE_TOOLBAR-BORDER-COLOR": "Colore tratto (nodo e freccia)",
  "FORMAT_NODE_TOOLBAR-BORDER-SIZE": "Spessore tratto",
  "FORMAT_NODE_TOOLBAR-BREAK-LINK": "Spezza freccia",
  "FORMAT_NODE_TOOLBAR-BRING-TO-FRONT": "Porta sopra",
  "FORMAT_NODE_TOOLBAR-ELLIPSE": "Ellisse",
  "FORMAT_NODE_TOOLBAR-FONT": "Carattere",
  "FORMAT_NODE_TOOLBAR-FONT-SIZE": "Dimensione carattere",
  "FORMAT_NODE_TOOLBAR-FRAME-IMAGE": "Metti e togli cornice immagine",
  "FORMAT_NODE_TOOLBAR-HIGHLIGHT": "Evidenziatore",
  "FORMAT_NODE_TOOLBAR-INSIDE": "Dentro",
  "FORMAT_NODE_TOOLBAR-MYCOLOR": "I miei colori",
  "FORMAT_NODE_TOOLBAR-NODE-SHAPE": "Cornice nodo",
  "FORMAT_NODE_TOOLBAR-NONE": "Nascondi",
  "FORMAT_NODE_TOOLBAR-OVER": "Sopra",
  "FORMAT_NODE_TOOLBAR-RECTANGLE": "Rettangolo",
  "FORMAT_NODE_TOOLBAR-REMOVE-IMAGE": "Cancella immagine",
  "FORMAT_NODE_TOOLBAR-ROUNDRECT": "Arrotondato",
  "FORMAT_NODE_TOOLBAR-SEND-TO-BACK": "Porta sotto",
  "FORMAT_NODE_TOOLBAR-STRAIGHTEN-EDGE": "Raddrizza freccia",
  "FORMAT_NODE_TOOLBAR-TEXT-COLOR": "Colore carattere",
  "FORMAT_NODE_TOOLBAR-TEXT-POSITION": "Posizione testo",
  "FORMAT_NODE_TOOLBAR-TEXT": "Nessuna cornice",
  "FORMAT_NODE_TOOLBAR-UNDER": "Sotto",
  "FORMAT_NODE_TOOLBAR-CURVE-EDGE": "Tipo freccia",
  "EDGE_STRAIGHT": "Dritta",
  "EDGE_CURVE": "Curva",
  "FOUND_IN": "Trovato in",
  "FROM-CAMERA": "Tramite fotocamera",
  "FROM-GOOGLEDRIVE": "Da Google Drive",
  "FROM-GOOGLEIMAGES": "Da Google immagini",
  "FROM-LOCAL": "Dal dispositivo locale",
  "FROM-URL": "Tramite URL",
  "FULLSCREEN-EXIT": "Visualizza in finestra",
  "FULLSCREEN": "Visualizza a tutto schermo",
  "GATEWAY_TIMEOUT": "Connessione assente",
  "GD3P_TEXT_01": "C'è stato un problema di accesso alla tua mappa su Google Drive.",
  "GD3P_TEXT_02": "Questo non è un errore di SMX studio.",
  "GD3P_TEXT_03": "L'amministratore del tuo dominio ha disabilitato l'uso delle app di terze parti.",
  "GD3P_TEXT_04": "Contatta l'amministratore del tuo dominio e chiedi di attivare le app di terze parti su Google Drive.",
  "GD3P_TEXT_05": "Per informazioni tecniche riguardo all'attivazione clicca questo <a href=\"https://support.google.com/a/answer/6105699?hl=it\">link</a>.",
  "GD3P_TITLE": "PROBLEMA DI ACCESSO ALLA MAPPA",
  "GDNFU_TEXT_01": "Non stai usando il primo utente loggato di <b>Google</b>!",
  "GDNFU_TEXT_02": "A causa di una limitazione della libreria di <b>Google Drive</b>",
  "GDNFU_TEXT_03": "per utilzzare questa funzione devi uscire da tutti gli account di <b>Google</b>",
  "GDNFU_TEXT_04": "e rientrare con l'utente attuale:",
  "GDNFU_TEXT_05": "In alternativa, puoi usare la funzione di condivisione integrata",
  "GDNFU_TEXT_06": "direttamente sulle pagine di <b>Google Drive</b>.",
  "GDRIVE_NEW_FILE_ERROR_GENERIC_MAP_NEW": "Non riesco ad creare la mappa",
  "GDRIVE_NEW_TITLE": "Creazione nuova mappa in corso...",
  "GDRIVE_OPEN_FILE_ERROR_GENERIC_MAP_OPEN": "Non riesco ad aprire la mappa",
  "GDRIVE_OPEN_TITLE": "Apertura della mappa in corso...",
  "GDRIVE_PICKER_BACK_TO_HOME": "Torna alla home",
  "GDRIVE_PICKER_ERROR_GENERIC_MAP_OPEN": "Non riesco ad aprire la mappa",
  "GDRIVE_PICKER_ERROR_LOADING_PICKER": "Non riesco ad accedere a Google Drive",
  "GDRIVE_PICKER_TITLE": "Scegli il file",
  "GE_CODE": "Codice di errore",
  "GENERAL_CANCEL": "Annulla",
  "GENERAL_OK": "Ok",
  "GENERIC_TOOLBAR-BACKGROUND-COLOR": "Colore sfondo mappa",
  "GENERIC_TOOLBAR_CHANGE-BACKGROUND-COLOR": "Cambia colore sfondo",
  "GENERIC_TOOLBAR_GRID": "Griglia",
  "GENERIC_TOOLBAR_ARRANGE": "Ridisponi Mappa",
  "GENERIC_TOOLBAR_INSERT_NEW": "Inserisci",
  "GENERIC_TOOLBAR_INSERT_NEW_NODE": "Inserisci nodo",
  "GENERIC_TOOLBAR_INSERT_NEW_TABLE": "Inserisci tabella",
  "GENERIC_TOOLBAR_MATH_EDITOR": "Matematica",
  "GENERIC_TOOLBAR_TABLE-SIZE": "Dimensioni tabella",
  "GENERIC_TOOLBAR_TABLE": "Tabella",
  "GE_TEXT_01": "Si è verificato un errore durante l'utilizzo di SMX studio",
  "GE_TEXT_02": "Per ripristinarlo puoi provare a fare una di queste azioni:",
  "GE_TEXT_03": "• Controlla di avere la connessione internet funzionante",
  "GE_TEXT_04": "• Ricarica la pagina (F5)",
  "GE_TEXT_05": "• Esci da SMX studio (logout) e rientra (login)",
  "GE_TEXT_06": "Premi OK per chiudere questo messaggio",
  "GOOGLE_DOC_CREATED": "Documento creato",
  "GOOGLE_DOC_UPDATED": "Documento aggiornato",
  "GOOGLE_DOC": "Documento Google",
  "GOOGLE_DOC_MENU": "Documento creato",
  "GOOGLE": "Google",
  "GOOGLE_IMAGES": "Google immagini",
  "HEADER_ABOUT": "Informazioni su SMX studio",
  "HEADER_ADMIN": "Gestisci abbonamenti",
  "HEADER_FAQ": "FAQ",
  "HEADER_HOME": "Home",
  "HEADER_INFO_COPYRIGHT": "(C)opyright Anastasis Soc. Coop. Soc.",
  "HEADER_INFO": "Informazioni",
  "HEADER_LANGUAGE": "Lingua",
  "HEADER_LOGOUT": "Esci da SMX studio",
  "HEADER_LOGOUT_SUB": "Uscendo dall'app rimarrai comunque loggato in Google",
  "HEADER_MANUAL": "Manuale",
  "HEADER_MAPINTRO": "Video manuale",
  "HEADER_PRIVACY": "Privacy e sicurezza",
  "HEADER_USER": "Utente",
  "HEADER_LINKS": "Collegamenti Chrome Touch",
  "HEADER_LINKS_WINDOWS": "Windows",
  "HEADER_LINKS_LINUX": "Linux",
  "HEADER_LINKS_MAC": "Mac",
  "HOME_ERROR_GENERIC_MAP_LOAD": "Non riesco ad aprire la mappa",
  "HOME_ERROR_GENERIC_RECENT": "Non riesco a caricare i recenti",
  "HOME_TITLE": "Home",
  "IC_TITLE": "L'accesso a SMX studio ti è stato negato in quanto non risulti coperto da alcun abbonamento.",
  "IC_SUBTITLE": "Per utilizzare SMX studio è necessario un abbonamento",
  "IC_BTN_WEBSITE_PRIVATE": "Sei un privato? Acquista",
  "IC_BTN_WEBSITE_SCHOOL": "Sei una scuola? Scopri l'offerta",
  "IC_DEMO_REQUEST_BUTTON": "Richiedi periodo di prova",
  "IC_LOGOUT": "Vuoi accedere con un altro utente?",
  "IC_LOGOUT_BUTTON": "Torna al login",
  "IC_LOGIN_BUTTON": "Vai al login",
  "IC_REQUEST_DEMO_1": "Prova SMX studio completo gratuitamente per 30 giorni con tutte le funzionalità",
  "IC_REQUEST_DEMO_2": "Al termine del periodo dimostrativo potrai acquistare un abbonamento.",
  "IC_WEBSITE": "Vai al sito di SMX studio dove potrai vedere prezzi e offerte e acquistare il tuo abbonamento.",
  "IC_SUB_TYPE_TITLE": "Tipo di abbonamento",
  "IC_SUB_TYPE_SUB": "Nuovo abbonamento",
  "IC_SUB_TYPE_RENEW": "Rinnovo su",
  "IC_USER_NAME": "Il dimostrativo verrà attivato per l'utente",
  "IC_USER_EMAIL": "che potrà accedere nel periodo di prova utilizzando la mail",
  "IC_USER_NAME_EMAIL": "Il dimostrativo verrà attivato per l'utente che potrà accedere nel periodo di prova utilizzando la mail indicata",
  "IC_USER_TYPE_TITLE": "Tipologia di utenza",
  "IC_USER_TYPE": "Indica la tua tipologia di utenza",
  "IC_USER_TYPE_": "<Non impostato>",
  "IC_USER_TYPE_PRIVATO": "Privato",
  "IC_USER_TYPE_INSEGNANTE": "Insegnante",
  "IC_USER_TYPE_EDUCATORE": "Educatore",
  "IC_USER_TYPE_FIGURA_CLINICA": "Figura clinica",
  "IC_USER_TYPE_LOGOPEDISTA": "Logopedista",
  "IC_USER_TYPE_ASL": "ASL",
  "IC_USER_TYPE_SCUOLA": "Scuola",
  "IC_USER_TYPE_UNIVERSITA": "Università",
  "IC_USER_TYPE_DOPOSCUOLA": "Operatore doposcuola",
  "IMAGE_COPIED": "Immagine mappa copiata negli appunti",
  "IMAGE": "Immagini",
  "IMAGE_NODE": "Immagine nodo",
  "IMAGE_NOT_COPIED": "ERRORE DURANTE LA COPIA DELLA MAPPA!",
  "IMAGE_TOOLBAR": "Inserisci immagini",
  "INFORMATION": "Informazioni",
  "INPUT-IMAGE-URL": "Incolla url immagine",
  "INPUT_LINK_URL": "Indirizzo del collegamento",
  "INPUT_LINK_URL_PREVIEW": "Non modificare immagine e titolo del nodo",
  "INPUT_MAPNAME": "Nome",
  "INSERT-ATTACHMENT": "Inserisci allegato",
  "INSERT_BLOCKNOTES": "Inserisci nel block notes",
  "INSERT_IMAGE": "Inserisci immagine",
  "INSERT-IMAGE": "Inserisci immagini",
  "INSERT_IN_MAP": "Inserisci nella mappa",
  "INSERT_MATH": "Matematica",
  "INSERT": "Inserisci",
  "INSERT_LINK": "Inserisci link",
  "ITEMS_PER_PAGE_LABEL": "Per pagina:",
  "LANGUAGE_TOOLBAR": "Lingua",
  "LAST_PAGE_LABEL": "Ultima pagina",
  "LIABILITY_CONTENT": "<br/><h2><b>Dichiarazione di responsabilità sui contenuti</b></h2><div><p>Dichiaro di assumermi la responsabilità legale dei contenuti che inserirò e condividerò in SMX studio.</p></div>",
  "LIABILITY_ERROR": "Non è possibile proseguire se non si conferma la dichiarazione di responsabilità sui contenuti",
  "LINK_COPIED": "Collegamento copiato negli appunti",
  "LINKS-GOOGLE-DRIVE": "Da Google Drive",
  "LINKS": "Link",
  "LINKS-MAP": "Mappa",
  "LINKS-VIDEO": "Video",
  "LINK_UNAVAILABLE": "Collegamento non disponibile",
  "LOGIN": "ACCEDI",
  "LOGIN_COMMAND_LOGIN": "Accedi con Google",
  "LOGIN_COOKIES_INFO": "Come abilitare i cookies di terze parti",
  "LOGIN_COOKIES_URL": "https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=it&oco=0",
  "LOGIN_FIRST_1": "È il tuo primo accesso?",
  "LOGIN_FIRST_2": "Consulta i documenti relativi alla nostra",
  "LOGIN_MOBILE_1": "Il funzionamento di SMX studio non è assicurato",
  "LOGIN_MOBILE_2": "se utilizzi il browser di un dispositivo mobile",
  "LOGIN_NEEDS_GOOGLE_ACCOUNT": "È necessario un abbonamento attivo a SMX studio.",
  "LOGIN_DISCOVER_MORE": "Scopri di più",
  "LOGIN_DOWNLOAD_APP": "Scarica l'applicazione:",
  "LOGIN_ERROR_GENERIC": "Errore durante l'autenticazione",
  "LOGIN_TITLE": "Accedi",
  "LOGIN_TITLE_DEMO": "Attiva dimostrativo",
  "LOGIN_LINK_PRIVACY": "Privacy policy",
  "LOGIN_MOBILE_WARNING": "ATTENZIONE",
  "LOGIN_MOBILE_MESSAGE": "Il funzionamento di SMX studio non è assicurato se utilizzi il browser di un dispositivo mobile.",
  "LOGIN_SUBSCRIPTION": "Non hai ancora un abbonamento attivo a SMX studio?",
  "LOGIN_MAPS_AND_MORE": "MAPPE e non solo",
  "LOGIN_UNDER_MAPS": "Mappe",
  "LOGIN_UNDER_NOTEPAD": "Appunti",
  "LOGIN_UNDER_DRAW": "Disegna",
  "LOGIN_UNDER_OUTLINE": "Outline",
  "LOGIN_UNDER_PDF": "PDF",
  "LOGIN_UNDER_MATH": "Matematica",
  "MADE_WITH": "fatta con SMX studio (C) Anastasis Soc.Coop.Soc.",
  "MAIL_SENT": "Email inviata",
  "MAIN_MENU_ARRANGE-ALIGN": "Allinea",
  "MAIN_MENU_ARRANGE-ALIGN-BOTTOM": "In basso",
  "MAIN_MENU_ARRANGE-ALIGN-HORZCENTER": "Al centro (orizzontale)",
  "MAIN_MENU_ARRANGE-ALIGN-LEFT": "A sinistra",
  "MAIN_MENU_ARRANGE-ALIGN-RIGHT": "A destra",
  "MAIN_MENU_ARRANGE-ALIGN-TOP": "In alto",
  "MAIN_MENU_ARRANGE-ALIGN-VERTCENTER": "Al centro (verticale)",
  "MAIN_MENU_ARRANGE": "Disponi",
  "MAIN_MENU_ARRANGE-ORDER-BRINGTOFRONT": "Porta sopra",
  "MAIN_MENU_ARRANGE-ORDER": "Ordina",
  "MAIN_MENU_ARRANGE-ORDER-SENDTOBACK": "Porta sotto",
  "MAIN_MENU_ARRANGE-SIZE": "Ridimensiona",
  "MAIN_MENU_ARRANGE-SIZE-SAMEHEIGHT": "Altezze uguali",
  "MAIN_MENU_ARRANGE-SIZE-SAMESIZE": "Dimensioni uguali",
  "MAIN_MENU_ARRANGE-SIZE-SAMEWIDTH": "Larghezze uguali",
  "MAIN_MENU_EDIT-BACKGROUND": "Colore sfondo",
  "MAIN_MENU_EDIT-COPY-ALL": "Tutto",
  "MAIN_MENU_EDIT-COPY": "Copia",
  "MAIN_MENU_EDIT-COPY-DEEP": "Approfondimento",
  "MAIN_MENU_EDIT-COPY-IMAGE": "Immagine",
  "MAIN_MENU_EDIT-COPY-LINK": "Allegato",
  "MAIN_MENU_EDIT-COPY-MAP-IMAGE": "Copia immagine mappa",
  "MAIN_MENU_EDIT-COPY-TEXT": "Testo",
  "MAIN_MENU_EDIT-CUT": "Taglia",
  "MAIN_MENU_EDIT-DELETE": "Elimina",
  "MAIN_MENU_EDIT": "Modifica",
  "MAIN_MENU_EDIT-PASTE": "Incolla",
  "MAIN_MENU_EDIT-REDO": "Ripeti",
  "MAIN_MENU_EDIT-TEXT": "Titolo nodo",
  "MAIN_MENU_EDIT-UNDO": "Annulla",
  "MAIN_MENU_FILE-COPY-MAP": "Crea una copia",
  "MAIN_MENU_FILE-CREATE-A-COPY": "Crea una copia...",
  "MAIN_MENU_FILE-CREATE-A-DOC": "Crea un documento Google",
  "MAIN_MENU_FILE-DOC": "Documento creato",
  "MAIN_MENU_FILE-EXPORT": "Scarica come...",
  "MAIN_MENU_FILE-EXPORT-TO-IMAGE": "Immagine (jpg)",
  "MAIN_MENU_FILE-EXPORT-TO-IMAGE-QRCODES": "Immagine + QRcode (jpg)",
  "MAIN_MENU_FILE-EXPORT-TO-MAP": "Mappa (sme)",
  "MAIN_MENU_FILE-EXPORT-TO-IMAGE-PDF": "Immagine (PDF)",
  "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-PDF": "Documento (PDF)",
  "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-DOCX": "Documento (Docx)",
  "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-DOCX-MS": "per Microsoft Office",
  "MAIN_MENU_FILE-EXPORT-TO-DOCUMENT-DOCX-LO": "per LibreOffice",
  "MAIN_MENU_FILE": "File",
  "MAIN_MENU_FILE-IMPORT-MAP": "Importa mappa",
  "MAIN_MENU_FILE-LIM-KEYBOARD": "L.I.M. con tastiera",
  "MAIN_MENU_FILE-LIM-ONLY-TOUCH": "L.I.M. solo Touch",
  "MAIN_MENU_FILE-LIM-PREFERENCES": "L.I.M.",
  "MAIN_MENU_FILE_MAP-LANGUAGE": "Lingua mappa",
  "MAIN_MENU_FILE-NEW-MAP": "Nuova mappa",
  "MAIN_MENU_FILE-OPEN-DOC": "Apri il documento",
  "MAIN_MENU_FILE-OPEN-MAP": "Apri mappa",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-ALL": "Tutte le immagini",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER": "Filtro immagini",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE-COM": "Immagini utilizzabili, anche commerciale",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE": "Immagini liberamente utilizzabili",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE-MOD-COM": "Immagini utilizzabili e modificabili, anche commerciale",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-FREE-MOD": "Immagini utilizzabili e modificabili",
  "MAIN_MENU_FILE-PREFERENCES-IMAGE-FILTER-SAFESEARCH": "Escludi immagini inappropriate: ATTIVO",
  "MAIN_MENU_FILE-PREFERENCES": "Impostazioni",
  "MAIN_MENU_FILE-PREFERENCES-PRINT-DRAFT": "Bozza",
  "MAIN_MENU_FILE-PREFERENCES-PRINT-HIGH": "Alta",
  "MAIN_MENU_FILE-PREFERENCES-PRINT-MAXIMUM": "Massima",
  "MAIN_MENU_FILE-PREFERENCES-PRINT-NORMAL": "Normale",
  "MAIN_MENU_FILE-PREFERENCES-PRINT": "Qualità di stampa",
  "MAIN_MENU_FILE-PREFERENCES-PRINT-VERYHIGH": "Molto alta",
  "MAIN_MENU_FILE-PRINT-MAP": "Mappa",
  "MAIN_MENU_FILE-PRINT-MAP-QRCODES": "Mappa + QRcode",
  "MAIN_MENU_FILE-PRINT": "Stampa",
  "MAIN_MENU_FILE-RENAME": "Rinomina",
  "MAIN_MENU_FILE-REVISION-HISTORY": "Cronologia Versioni",
  "MAIN_MENU_FILE-SHARE": "Condividi",
  "MAIN_MENU_FILE-SHOW-MAP": "Presenta mappa",
  "MAIN_MENU_FILE-TEXT-BACKCOLOR": "Evidenziatore",
  "MAIN_MENU_FILE-TEXT-COLOR": "Colore carattere",
  "MAIN_MENU_FILE-TEXT-PREFERENCES": "Testo",
  "MAIN_MENU_FILE-TOUCH-PREFERENCES": "Abilita touch (FAQ)",
  "MAIN_MENU_FILE-UPDATE-DOC": "Aggiorna il documento",
  "MAIN_MENU_FILE-VIEW-MAP": "Visualizza mappa",
  "MAIN_MENU_FORMAT-ARROW-BREAKARROW": "Spezza freccia",
  "MAIN_MENU_FORMAT-ARROW-COLOR": "Colore linea",
  "MAIN_MENU_FORMAT-ARROW": "Freccia",
  "MAIN_MENU_FORMAT-ARROW-LEFTARROW": "Freccia indietro",
  "MAIN_MENU_FORMAT-ARROW-RIGHTARROW": "Freccia avanti",
  "MAIN_MENU_FORMAT-ARROW-STRAIGHTEN": "Raddrizza freccia",
  "MAIN_MENU_FORMAT-ARROW-THICKNESS": "Spessore",
  "MAIN_MENU_FORMAT": "Formato",
  "MAIN_MENU_FORMAT-NODE-BACKCOLOR": "Colore sfondo nodo",
  "MAIN_MENU_FORMAT-NODE-COLOR": "Colore tratto",
  "MAIN_MENU_FORMAT-NODE-DELETEIMAGE": "Cancella immagine",
  "MAIN_MENU_FORMAT-NODE-IMAGEFRAME": "Metti/Togli cornice immagine",
  "MAIN_MENU_FORMAT-NODE": "Nodo",
  "MAIN_MENU_FORMAT-NODE-SHAPE": "Cornice nodo",
  "MAIN_MENU_FORMAT-NODE-TEXTLAYOUT": "Posizione del testo",
  "MAIN_MENU_FORMAT-NODE-THICKNESS": "Spessore tratto",
  "MAIN_MENU_FORMAT-TABLE-DELETECOL": "Elimina colonna",
  "MAIN_MENU_FORMAT-TABLE-DELETEROW": "Elimina riga",
  "MAIN_MENU_FORMAT-TABLE-DELETETABLE": "Elimina tabella",
  "MAIN_MENU_FORMAT-TABLE-INSERTCOLAFTER": "Inserisci colonna dopo",
  "MAIN_MENU_FORMAT-TABLE-INSERTCOLBEFORE": "Inserisci colonna prima",
  "MAIN_MENU_FORMAT-TABLE-INSERTROWOVER": "Inserisci riga sopra",
  "MAIN_MENU_FORMAT-TABLE-INSERTROWUNDER": "Inserisci riga sotto",
  "MAIN_MENU_FORMAT-TABLE": "Tabella",
  "MAIN_MENU_FORMAT-TEXT-BACKCOLOR": "Evidenziatore",
  "MAIN_MENU_FORMAT-TEXT-COLOR": "Colore carattere",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS-BOLD": "Grassetto",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS": "Effetti",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS-ITALIC": "Corsivo",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS-SUBSCRIPT": "Pedice",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS-SUPERSCRIPT": "Apice",
  "MAIN_MENU_FORMAT-TEXT-EFFECTS-UNDERLINE": "Sottolineato",
  "MAIN_MENU_FORMAT-TEXT-FONTSIZE": "Dimensione",
  "MAIN_MENU_FORMAT-TEXT-FONT": "Tipo carattere",
  "MAIN_MENU_FORMAT-TEXT-LANGUAGE": "Lingua selezione",
  "MAIN_MENU_FORMAT-TEXT": "Testo",
  "MAIN_MENU_INSERT-DEEPTEXT": "Approfondimento",
  "MAIN_MENU_INSERT": "Inserisci",
  "MAIN_MENU_INSERT-LINK-GOOGLE-DRIVE": "Da Google Drive",
  "MAIN_MENU_INSERT-LINK": "Link",
  "MAIN_MENU_INSERT-LINK-MAP": "Mappa",
  "MAIN_MENU_INSERT-NODE": "Nodo",
  "MAIN_MENU_INSERT-QUICKEDIT": "Inserimento rapido",
  "MAIN_MENU_INSERT-QUICKSPEECH": "Inserimento vocale",
  "MAIN_MENU_INSERT-TABLE": "Tabella",
  "MAIN_MENU_VIEW-CLOSE-NODES": "Chiudi tutti i nodi",
  "MAIN_MENU_VIEW-FIT": "Adatta (centra mappa)",
  "MAIN_MENU_VIEW-GRID": "Griglia",
  "MAIN_MENU_VIEW-OPEN-NODES": "Apri tutti i nodi",
  "MAIN_MENU_VIEW-QRCODE-GDOC": "Documento Google",
  "MAIN_MENU_VIEW-QRCODE-MAP": "Mappa",
  "MAIN_MENU_VIEW-QRCODE": "QR code",
  "MAIN_MENU_VIEW": "Visualizza",
  "MAIN_MENU_VIEW-ZOOM-100": "Zoom 100%",
  "MAIN_MENU_VIEW-ZOOM-IN": "Zoom avanti",
  "MAIN_MENU_VIEW-ZOOM-OUT": "Zoom indietro",
  "MAIN_MENU_TOOLS": "Strumenti",
  "MAINTENANCE": "Sito in manutenzione",
  "MAIN_TOOLBAR_BLOCKNOTES": "Appunti",
  "MAIN_TOOLBAR_ADD_TOOLS": "Strumenti aggiuntivi",
  "MAIN_TOOLBAR_CHAT": "Chat",
  "MAIN_TOOLBAR_CLEARREADORDER": "Pulisci",
  "MAIN_TOOLBAR_CLOSE_NODES": "Ricomincia presentazione",
  "MAIN_TOOLBAR_DEFAULTREADORDER": "Ordine di default",
  "MAIN_TOOLBAR_EDITSHOW": "Modifica",
  "MAIN_TOOLBAR_EXPORT-TO-IMAGE": "Scarica come immagine",
  "MAIN_TOOLBAR_EXPORT-TO-SME": "Scarica come sme",
  "MAIN_TOOLBAR_EXTRA": "Extra",
  "MAIN_TOOLBAR_FIND": "Cerca nella mappa",
  "MAIN_TOOLBAR_GOTOEDITMODE": "Torna alla mappa",
  "MAIN_TOOLBAR_HISTORY": "Versioni",
  "MAIN_TOOLBAR_INTERACTION_MODE": "Manina",
  "MAIN_TOOLBAR_MODIFYTEXT": "Modifica testo",
  "MAIN_TOOLBAR_OPEN_NODES": "Mostra tutta la mappa",
  "MAIN_TOOLBAR_OUTLINE": "Outline",
  "MAIN_TOOLBAR_PDF": "PDF",
  "MAIN_TOOLBAR_QRCODE": "Condividi con QRcode",
  "MAIN_TOOLBAR_QUICKEDIT": "Inserimento rapido",
  "MAIN_TOOLBAR_REDO": "Ripeti",
  "MAIN_TOOLBAR_SEARCHWEB": "Cerca nel web",
  "DRAW_TOOLS": "Strumenti per il disegno",
  "DESMOS_MATH_TOOLS": "Strumenti per la matematica",
  "AUTODRAW_DESC_1": "Autodraw è un servizio offerto da ",
  "DESMOS_DESC_1": "Gli strumenti Desmos sono forniti da ",
  "DESMOS_DESC_2": "Anastasis non fornisce assistenza o garanzia su questi servizi.",
  "DESMOS_DESC_3": "Per poter utilizzare questi strumenti e averli a disposizione nel menu Extra",
  "DESMOS_DESC_4": " è necessario abilitarli dal menù sottostante e salvare.",
  "DESMOS_CALCULATOR": "Elaboratore grafico",
  "DESMOS_SCIENTIFIC": "Calcolatrice scientifica",
  "DESMOS_FOURFUNCTIOM": "Calcolatrice semplice",
  "DESMOS_GEOMETRY": "Editor di geometria",
  "AUTODRAW": "Autodraw",
  "MAIN_TOOLBAR_SHARE_CLASSROOM": "Condividi su Google Classroom",
  "MAIN_TOOLBAR_SHARE-FB": "Condividi su Facebook",
  "MAIN_TOOLBAR_SHOWHELP_ADD": "clicca il nodo per aggiungere un passaggio alla presentazione",
  "MAIN_TOOLBAR_SHOWHELP_REMOVE": "clicca il numero per eliminare il passaggio dalla presentazione",
  "MAIN_TOOLBAR_SPEECHEDIT": "Inserimento vocale",
  "MAIN_TOOLBAR_STARTSHOW": "Avvia",
  "MAIN_TOOLBAR_TEXT-TO-SPEECH-ENABLE": "Enable text to speech",
  "MAIN_TOOLBAT_TEXT-TO-SPEECH-DISABLE": "Disable text to speech",
  "MAIN_TOOLBAR_UNDO": "Annulla",
  "MAIN_TOOLBAR_ZOOM-FIT": "Centra mappa",
  "MAIN_TOOLBAR_ZOOM_IN": "Ingrandisci",
  "MAIN_TOOLBAR_ZOOM_OUT": "Rimpicciolisci",
  "MAIN_TOOLBAR_ZOOM_SELECTION": "Zoom sulla selezione",
  "MANAGE_SHARINGS_MAP": "Condivisione avanzata",
  "MAP_AUTH": "Autorizzazioni",
  "MAPEDIT_ERROR_GENERIC_MAP_LOAD": "Non riesco ad aprire la mappa",
  "MAPEDIT_LOADING": "Caricamento...",
  "MAPEDIT_TITLE": "Mappa",
  "MAP_DELETEDATE": "Cancellazione",
  "MAP_LASTUPDATE": "Ultima modifica",
  "MAP_NAME": "Nome",
  "MAP_PUBLIC": "pubblica",
  "MAPSHARED_TITLE": "Mappa",
  "MAP_SHARING": "Condivisione",
  "MAPVIEW_TITLE": "Mappa",
  "MATH_OK": "Conferma",
  "MATH_CANCEL": "Svuota",
  "MATH_LATEX": "LaTeX",
  "MATH_LATEX_INFO": "Informazioni sull'uso di LaTeX",
  "MATH_LATEX_INFO_MESSAGE": "<div><b>Per entrare in modalità LaTeX</b><br/>Premere il bottone <b>LaTeX</b> sulla barra o il tasto <b>\\</b> della tastiera.</div><br/><div><b>Come ottenere i suggerimenti</b><br/>Una volta in modalità LaTeX, premere il tasto <b>\\</b> della tastiera e cominciare a scrivere in LaTeX.</div><br/><div><b>Come selezionare un suggerimento</b><br/>Muovere il cursore tra le varie opzioni con i <b>tasti freccia</b> e premere <b>TAB</b> per riportare l'elemento elezionato nella formula corrente.</div><br/><div><b>Come uscire dalla modalità LaTex</b><br/>Ci sono diversi modi: <ul><li>Premere il bottone <b>LaTeX</b> sulla barra</li><li>Premere il tasto <b>ESC</b> sulla tastiera</li><li>Premere il tasto <b>HOME</b> sulla tastiera</li></ul></div>",
  "MATH_CLOSE": "Chiudi",
  "MATH_ERROR_FORMULA": "Errore nella formula",
  "MATH_ERROR_FORMULA_PLACEHOLDER": "Ci sono uno o più segnaposto ancora da riempire.",
  "MATH_ERROR_IMAGE": "Errore nella generazione dell'immagine",
  "MAX_ERROR": "Il numero massimo di utenti che si possono abilitare è 500",
  "MIN_ERROR": "Il numero di utenti ammessi è minore di quelli inseriti.",
  "MODALITY": "Modalità",
  "MOVE_HERE": "Sposta in",
  "MOVE_DOCS": "Sposta documenti",
  "MOVE_DOCS_OLDUSER": "Email vecchio utente (da)",
  "MOVE_DOCS_NEWUSER": "Email nuovo utente (a)",
  "MSG_ASK_CHANGE_NODE_LINK": "Il nodo contiene già testo o immagini. Vuoi aggiornarlo con i contenuti del link?",
  "MSG_ASK_CHANGE_NODE_MAP": "Il nodo contiene già testo o immagini. Vuoi aggiornarlo con i contenuti della mappa?",
  "MSG_MAP_DOES_NOT_EXIST": "Questa mappa non è mai stata aperta su SMX studio. Devi prima aprirla per poterla utilizzare come collegamento.",
  "MSG_NO_VIDEOREC_SUPPORTED": "Il registratore video è supportato solamente per <b>Windows</b>.",
  "MSG_MISSING_PRIVACY_TEXT": "Non hai ancora dato i  consensi al trattamento dei dati personali.<br>Premi Ok per rifare il login e assicurati di compilare il modulo di consenso della privacy.",
  "MSG_MISSING_PRIVACY_TITLE": "Privacy mancante",
  "MSG_OCRSCAN_OK": "Scansione effettuata con successo.",
  "MSG_OCRSCAN_NO_SCANS_LEFT": "Non hai più scansioni a disposizione.",
  "MSG_OCRSCAN_ERROR_SEARCH_SCANCOUNT": "Errore nella fase di ricerca del contatore scansioni.",
  "MSG_OCRSCAN_ERROR_DECREASE_SCANCOUNT": "Errore nel decremento del contatore scansioni.",
  "MSG_OCRSCAN_ERROR_MATHPIX": "Errore durante la chiamata al server.",
  "MSG_OCRSCAN_GENERIC_ERROR": "Errore generico scansione OCR.",
  "OCRSCAN": "OCR Matematico",
  "OCRSCAN_WAIT": "Sto caricando l'immagine, attendi un attimo...",
  "OCRSCAN_LEFT_PERSONAL_N": "Hai ancora %n scansioni residue",
  "OCRSCAN_LEFT_GROUP_N": "Il tuo gruppo di lavoro ha %n scansioni residue",
  "OCRSCAN_LEFT_PERSONAL_1": "Hai ancora %n scansione residua",
  "OCRSCAN_LEFT_GROUP_1": "Il tuo gruppo di lavoro ha %n scansione residua",
  "OCRSCAN_PERIOD_MONTH": "nel mese corrente",
  "OCRSCAN_PERIOD_ALL": "in totale",
  "OCRSCAN_POLICY_FREE": "in totale",
  "OCRSCAN_POLICY_MONTHLY": "al mese per tutto il gruppo",
  "OCRSCAN_POLICY_MONTHLY-USER": "al mese per utente del gruppo",
  "OCRSCAN_LEFT": "OCR Scansioni rimanenti",
  "OCRSCAN_OVER": "Non hai più scansioni a disposizione",
  "CROP_IMAGE_COPY": "Copia",
  "CROP_IMAGE_COPY_MSG": "Immagine copiata in clipboard",
  "MSG_USER_CANT_SHARE": "Non hai i permessi per condividere questa mappa",
  "MSG_VIDEOREC_INFO_01": "Il registratore video di SMX studio",
  "MSG_VIDEOREC_INFO_02": "Il servizio di registrazione video e lo spazio cloud sono forniti da <a href='https://www.apowersoft.com/', target='_blank'>Apowersoft Ltd</a>.",
  "MSG_VIDEOREC_INFO_03": "Anastasis non fornisce assistenza o garanzie su questo servizio.",
  "MSG_VIDEOREC_INFO_04": "Per poter utilizzare il registratore video è necessario <b>installare il launcher</b>.",
  "MSG_VIDEOREC_INFO_05": "1. Clicca [<b>Registra video</b>] per attivare il registratore.",
  "MSG_VIDEOREC_INFO_06": "2. <i>Personalizza</i> le modalità di registrazione, quindi clicca [<b>REC</b>] per avviare la registrazione.",
  "MSG_VIDEOREC_INFO_07": "3. Quando hai finito, clicca il pulsante [<b>STOP</b>] e [<b>SALVA</b>] il video.",
  "MSG_VIDEOREC_INFO_08": "Puoi trovare maggiori dettagli sull'utilizzo del registratore video nel manuale di SMX studio.",
  "MSG_VIDEOREC_SUB_01": "Schermo intero",
  "MSG_VIDEOREC_SUB_02": "Area",
  "MSG_VIDEOREC_SUB_03": "Audio sistema",
  "MSG_VIDEOREC_SUB_04": "Webcam",
  "NEW_MAP_NAME": "Nuova mappa",
  "NEW_MAP": "Nuova mappa",
  "CREATE_NEW_MAP": "Crea nuova mappa",
  "NEWSLETTER_CONTENT_1": "<h2><b>Iscrizione alla newsletter</b></h2>",
  "NEWSLETTER_CONTENT_2": "Iscriviti alla newsletter per restare aggiornato sulle ultime novità Anastasis.",
  "NEWSLETTER_DIALOG_TITLE": "Iscrizione alla newsletter",
  "NEWSLETTER_INFO": "Informazioni sulla newsletter",
  "NEXT_PAGE_LABEL": "Prossima pagina",
  "NEXT_PAGE": "Pagina successiva",
  "NOBROWSER_TITLE": "Browser non compatibile",
  "NOCOLOR": "Nessun colore",
  "NO_GOOGLE_TITLE": "Impossibile accedere al login di Google",
  "NO_GOOGLE_MESSAGE_1": "Questo servizio non è disponibile per gli utenti che hanno meno di 14 anni e sono gestiti dal genitore tramite Family Link.",
  "NO_GOOGLE_MESSAGE_2": "Per risolvere il problema utilizza un account non legato al Family Link.",
  "NO_MAP_NAME": "Manca il nome della mappa",
  "NO_MAPS": "Non ci sono ancora Mappe",
  "NO_NOTIFICATIONS": "Nessuna notifica",
  "NO_SUBSCRIPTIONS": "Nessun abbonamento trovato",
  "NOT_A_GOOGLE_EMAIL_MSG": " non è una email di Google.",
  "NOTEPAD_READONLY": "Appunti in sola visualizzazione",
  "NOTES": "Appunti",
  "NOTIFICATION_CHECK": "Attiva",
  "NOTIFICATION_DATE": "Data evento",
  "NOTIFICATION_DESC": "Descrizione",
  "NOTIFICATION_DESC_PLACEHOLDER": "Inserisci descrizione notifica",
  "NOTIFICATION_EXPIRING_ACCOUNT": "Il tuo abbonamento è in scadenza",
  "NOTIFICATION_EXPIRING_DEMO": "Il tuo dimostrativo è in scadenza",
  "NOTIFICATION_EXPIRED_ACCOUNT": "Il tuo abbonamento è scaduto",
  "NOTIFICATION_EXPIRED_DEMO": "Il tuo dimostrativo è scaduto",
  "NOTIFICATION_INSERT": "Inserisci notifica",
  "NOTIFICATION_LINK": "Link",
  "NOTIFICATION_MANAGEMENT": "Gestione notifiche",
  "NOTIFICATIONS_EMPTY": "Non ci sono notifiche",
  "NOTIFICATIONS_INFO": "Riceverai informazioni su aggiornamenti, formazioni...",
  "NOTIFICATIONS_LIST": "Lista notifiche",
  "NOTIFICATIONS": "Notifiche",
  "NOTIFICATION_TITLE_PLACEHOLDER": "Inserisci titolo notifica",
  "NOTIFICATION_TITLE": "Titolo notifica",
  "NOTIFICATION_TYPE": "Tipo notifica",
  "NOT_OWNER_CANT_CREATE_GOOGLEDOC": "Solo il proprietario della mappa può generare il Google Document",
  "NOT_VALID_DOMAINLICS_MSG": " non è un numero di licenze valido.",
  "NOT_VALID_DOMAIN_MSG": " non è un dominio valido.",
  "EMPTY_DOMAIN_NOT_ALLOWED": "Non sono permessi domini vuoti",
  "NOT_VALID_EMAIL_MSG": " non è una email valida.",
  "NUM_COL": "Colonne",
  "NUM_ROW": "Righe",
  "OCR_SCANS_LEFT": "Scansioni residue",
  "OCR_LATEX_EMPTY": "Nessuna formula matematica riconosciuta",
  "OFFLINE_GENERIC": "Senza connessione non è possibile lavorare",
  "OFFLINE_LOGIN": "Senza connessione a internet non è possibile loggarsi",
  "OFFLINE_RECENT": "Senza connessione non è possibile lavorare",
  "OFFLINE_STATUS": "Connessione assente. Il salvataggio del documento verrà effettuato non appena tornerà la connessione",
  "OK": "Ok",
  "OOOPS": "Ooops!",
  "OOPS": "Oops!!!",
  "OPEN_FROM_GDRIVE": "Importa da Google Drive",
  "OPEN_FROM_LOCAL": "Carica mappa",
  "OPEN_PDF": "Da locale",
  "OPEN_GOOGLE_DOC": "Apri documento Google",
  "OPEN_IN_NEW_WINDOW": "Apri in una nuova finestra",
  "OPEN_INTRO_MAP": "Apri la mappa introduttiva",
  "ORDER-SUBSCRIPTIONID": "Chiave abbonamento",
  "ORDER-CREATEDBY": "Ordine creato da",
  "ORDER-CREATIONDATE": "Data creazione ordine",
  "ORDER-DOMAINLICS": "Numero utenze dominio",
  "ORDER-EXPIREDATE": "Data di scadenza",
  "ORDER-EXPIRED": "L'abbonamento è scaduto e non è possibile configurarlo.",
  "ORDER-FULLNAME": "Nome acquirente",
  "ORDER-LASTMODIFICATIONBY": "Autore ultima modifica",
  "ORDER-LASTMODIFICATIONDATE": "Data ultima modifica ordine",
  "ORDER-LICENSETYPE": "Tipo di licenza",
  "ORDER_MODIFIED": "Ordine modificato con successo",
  "ORDER-NETWORKUSERID": "ID utente",
  "ORDER-NOTES": "Note ordine",
  "ORDER-NOTFOUND-LINE1": "L'abbonamento non esiste",
  "ORDER-NOTFOUND-LINE2": "L'abbonamento è stato disattivato",
  "ORDER-NOTFOUND-LINE3": "Connessione di rete mancante o limitata",
  "ORDER-NOTFOUND-LINE4": "Il codice di sicurezza dell'abbonamento non corrisponde",
  "ORDER-NOTFOUND-SUB": "Alcune delle cause possibili sono:",
  "ORDER-NOTFOUND-TITLE": "Non è possibile configurare questo abbonamento",
  "ORDER-ORDERID": "Chiave abbonamento",
  "ORDER-ORIGIN": "Origine ordine",
  "ORDER-REFORDERID": "Ordine di riferimento",
  "ORDER-SLOTCOUNT": "Numero account",
  "ORDER-SUBMITTED-SUB": "Ora puoi chiudere questa scheda",
  "ORDER-SUBMITTED-TITLE": "Modifica effettuata correttamente",
  "ORDER-SUSPENDED": "L'abbonamento è stato disattivato e non è possibile configurarlo.",
  "ORDER-USEREMAIL": "Mail acquirente",
  "ORDER-HISTORY-TITLE": "Storico ordini",
  "ORDER-HISTORY-DATE": "Data:",
  "ORIGIN_AID": "Inserito da AID",
  "ORIGIN_ALL": "--- Tutti gli ordini ---",
  "ORIGIN_APP-STORE": "App Store",
  "ORIGIN_AZIONE-SMX-2020-2021": "Azione SMX 2020-2021",
  "ORIGIN_AZIONE-SMX-2021-2022": "Azione SMX 2021-2022",
  "ORIGIN_BUY": "Acquisto",
  "ORIGIN_DEMO": "Dimostrativo",
  "ORIGIN_DOPOSCUOLA": "Doposcuola",
  "ORIGIN_DS-SCUOLA-2020": "DS Adotta una scuola 2020",
  "ORIGIN_FAD": "FAD",
  "ORIGIN_MANUAL": "Inserito manualmente",
  "ORIGIN_RETE-ANA-SCUOLA": "Rete centro Anastasis-SCUOLA",
  "ORIGIN_PIEM-SPAOLO-2021": "Piemonte-Fond.S.Paolo 2021",
  "ORIGIN_PLAY-STORE": "Play Store",
  "ORIGIN_SMX-SCUOLE-2022": "SMX Scuole 2022",
  "ORIGIN_SPAIN": "Spagna",
  "ORIGIN_USR-ER": "Uff.scol.reg.Emilia Romagna",
  "ORIGIN_WEBINAR": "Webinar",
  "OTHER": "Altro",
  "OUTLINE": "Outline",
  "OUTLINE_ADD_ABOVE": "Aggiungi fratello",
  "OUTLINE_ADD_BELOW": "Aggiungi figlio",
  "OUTLINE_DELETE": "Elimina nodo e figli",
  "OUTLINE_EDIT": "Modifica",
  "OUTLINE_UP": "Sposta su",
  "OUTLINE_DOWN": "Sposta giù",
  "OUTLINE_IN": "Sposta dentro",
  "OUTLINE_OUT": "Sposta fuori",
  "OUTLINE_COPY": "Copia",
  "OUTLINE_PASTE": "Incolla",
  "OUTLINE_TITLE": "Nuovo nodo",
  "OUTLINE_SELECT_SUBTREE": "Seleziona sottoalbero",
  "OUTLINE_QUICK_INPUT": "Inserimento rapido",
  "OUTLINE_READONLY": "Outline in sola visualizzazione",
  "OUTLINE_TOOLTIP_DROP_PARENT": "Porta fuori",
  "OUTLINE_TOOLTIP_DROP_SIBLING": "Rendi fratello",
  "OUTLINE_TOOLTIP_DROP_CHILD": "Rendi figlio",
  "OUTLINE_ARRANGE": "Ridisponi mappa",
  "OUTLINE_ARRANGE_TABLE": "Tabella",
  "OUTLINE_NODE_VIEW_IMAGE_SHOW": "Mostra immagini",
  "OUTLINE_NODE_VIEW_IMAGE_HIDE": "Nascondi immagini",
  "OUTLINE_WARNING_1": "Incluso",
  "OUTLINE_WARNING_2": " fino a Gennaio 2024!",
  "PAGE_BACK": "Indietro",
  "PASTE_HERE": "Apri il menu contestuale ed incolla qui",
  "PASTE-OPTIONS": "OPZIONI INCOLLA",
  "PASTE-AS-TABLE": "INCOLLA COME TABELLA",
  "PASTE-AS-NODE": "INCOLLA COME NODO",
  "PASTE-AS-MAP": "INCOLLA COME MAPPA",
  "PASTE-AS-DEEP": "Metti negli approfondimenti il testo tra parentesi (...)",
  "PASTE-OPTIONS-TAB": "singola",
  "PASTE-OPTIONS-COLUMNS": "colonne separate",
  "PASTE-OPTIONS-ROWS": "righe separate",
  "PASTE-OPTIONS-ONE-NODE": "un solo nodo",
  "PASTE-OPTIONS-MANY-NODES": "tanti nodi singoli",
  "PASTE-OPTIONS-ONE-COLUMN": "una colonna",
  "PASTE-OPTIONS-ONE-ROW": "una riga",
  "PASTE-OPTIONS-NODES-VERT": "nodi in verticale",
  "PASTE-OPTIONS-NODES-HORIZ": "nodi in orizzontale",
  "PASTE-OPTIONS-MAP-UPDOWN": "ad albero",
  "PASTE-OPTIONS-MAP-RADIAL": "a raggiera",
  "PASTE-OPTIONS-MAP-LEFTRIGHT": "ad albero da sinistra",
  "PASTE-OPTIONS-MAP-DOWNUP": "ad albero dal basso",
  "PASTE-OPTIONS-MAP-RIGHTLEFT": "ad albero da destra",
  "PLAY": "Leggi",
  "PLEASE_WAIT": "Elaborazione in corso...",
  "PREF_COLOR": "Colore",
  "PREF_DEEP": "Approfondimento",
  "PREF_EDGE": "Freccia",
  "PREF_EFFECT_BOLD": "Grassetto",
  "PREF_EFFECT_NONE": "Nessuno",
  "PREF_EFFECTS": "Effetti",
  "PREF_TEXT_TITLE": "Testo",
  "PREF_FONT": "Font",
  "PREF_NODE_TITLE": "Nodo",
  "PREF_NODE_IMAGE": "Immagine nodo",
  "WITH_FRAME": "con cornice",
  "WITHOUT_FRAME": "senza cornice",
  "PREF_DESC_NODE_IMAGE": "Scegli se avere la cornice dei nodi con immagine. La cornice di un nodo con immagine può essere solo rettangolare.",
  "PREF_NOTE": "Appunti",
  "PREF_MATH": "Matematica",
  "PREF_RESET_MESSAGE": "Ripristinare i valori di default?",
  "PREF_RESET": "Ripristina default",
  "PREF_SIZE": "Dimensione font",
  "PREF_ASPECT_TITLE": "Aspetto",
  "PREF_SHAPE": "Forma",
  "PREF_SHAPE_RECT": "Rettangolo",
  "PREF_SHAPE_ELLIPSE": "Ellisse",
  "PREF_SHAPE_ROUNDRECT": "Arrotondato",
  "PREF_BACKGROUND_COLOR": "Colore sfondo",
  "PREF_BORDER_COLOR": "Colore bordo",
  "PREF_NODE_IMAGE_TITLE": "Immagine nodo",
  "PREF_EDGE_WIDTH": "Spessore",
  "PREF_EDGE_TYPE": "Tipo",
  "PREF_DESC_FREE_EDGE": "La curvatura della freccia libera può essere modificata manualmente",
  "FREE_EDGE": "Freccia libera",
  "PREF_EDGE_STRAIGHT": "Dritta",
  "PREF_EDGE_CURVE": "Curva",
  "PREVIOUS_PAGE_LABEL": "Pagina precedente",
  "PREV_PAGE": "Pagina precedente",
  "PREVIEW_NOT_AVAILABLE": "Anteprima non disponibile",
  "PRIVACY_AGE_REQUEST": "Indica la tua fascia d'età",
  "PRIVACY_AGE_OVER_18": "Ho più di 18 anni",
  "PRIVACY_AGE_UNDER_18": "Ho meno di 18 anni",
  "PRIVACY_CONFIRM": "Sì, confermo",
  "PRIVACY_HEADER": "<h1><b>Ancora un momento...</b></h1><div><p>Ci teniamo alla tua privacy e usiamo i tuoi dati solo se sono strettamente indispensabili per poter far funzionare SMX studio.</p></div><div><p>Prima di andare avanti, vogliamo essere sicuri che siano chiari i tuoi diritti e doveri sui tuoi dati e i tuoi contenuti che inserirai dentro SMX studio.</p></div><div><p>Qualora SMX studio venga usato da un minore, è necessario che le seguenti dichiarazioni siano lette e accettate da chi ne ha la responsabilità genitoriale.<br /><p style='color: red'>* indica i campi obbligatori</p></p></div><br/>",
  "PRIVACY_CONTENT_GENERIC": "<h2><b>Informativa sulla privacy</b></h2><div><p>Confermo di aver preso visione della %privacypolicy% ed esprimo il mio libero consenso al trattamento dei dati personali, come specificato nella suddetta policy.</p></div>",
  "PRIVACY_CONTENT_PRIVATE_EDU_LINK": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-privacy-privati.pdf' target='_blank'>Privacy policy di SMX studio modulo mappe per i privati</a>",
  "PRIVACY_CONTENT_SCHOOL_EDU_LINK": "<a href='https://privacy.smxstudio.it/mappe/smxstudio-mappe-privacy-scuole.pdf' target='_blank'>Privacy policy di SMX studio modulo mappe per le scuole</a>",
  "PRIVACY_CONTENT_UNIVERSITY_EDU_LINK": "<a href='https://privacy.smxstudio.it/mappe/smxstudio-mappe-privacy-universita.pdf' target='_blank'>Privacy policy di SMX studio per le università</a> ",
  "PRIVACY_CONTENT_PRIVATE_LAB_LINK": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-privacy-privati.pdf' target='_blank'>Privacy policy di SMX studio completo per i privati</a>",
  "PRIVACY_CONTENT_SCHOOL_LAB_LINK": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-privacy-scuole.pdf' target='_blank'>Privacy policy di SMX studio completo per le scuole</a>",
  "PRIVACY_CONTENT_UNIVERSITY_LAB_LINK": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-privacy-universita.pdf' target='_blank'>Privacy policy di SMX studio completo per le università</a>",
  "PRIVACY_PURPOSE": "<h3>Finalità del trattamento</h3>",
  "PRIVACY_PURPOSE_A": "a) creazione di un account per l’accesso alla piattaforma e utilizzazione del servizio SMX studio %planId% per la creazione e condivisione delle mappe concettuali multimediali, in contesto di didattica inclusiva e collaborativa (come previsto dall’art. 6 lett. b GDPR).",
  "PRIVACY_PURPOSE_B": "b) l’adempimento degli obblighi legali previsti dalla disciplina legale per le prescrizioni prevista dalla normativa fiscale e tributaria. Base giuridica del trattamento è l’adempimento di un obbligo legale (come previsto dall’art. 6 lett. c) GDPR).",
  "PRIVACY_PURPOSE_C": "c) per consentire la navigazione, la registrazione e l’accesso, il legittimo interesse del Titolare a rendere fruibile e sicura la navigazione (art. 6, par. 1 lett.f Regolamento UE 2016/679) e per l'accertamento, l'esercizio o la difesa di un diritto in sede giudiziale e stragiudiziale (legittimo interesse) delle scriventi organizzazioni (art. 6, par. 1 lett.f) Regolamento UE 2016/679).",
  "PRIVACY_DOC_DPA_GENERIC": "Dichiaro di aver letto e accettato i termini riportati nel documento %dpa%.",
  "PRIVACY_DOC_DPA_EDU": "<a href='https://privacy.smxstudio.it/mappe/smxstudio-mappe-dpa.pdf' target='_blank'>Data Processing Agreement SMX studio modulo mappe</a>",
  "PRIVACY_DOC_DPA_LAB": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-dpa.pdf' target='_blank'>Data Processing Agreement SMX studio completo</a>",
  "PRIVACY_DOC_CONTRACT_GENERIC": "Dichiaro di aver letto e accettato i termini riportati nel documento %contract%.",
  "PRIVACY_DOC_CONTRACT_PRIVATE_EDU": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-contratto-privati.pdf' target='_blank'>Contratto di servizi informatici per l'accesso alla piattaforma SMX studio modulo mappe per privati</a>",
  "PRIVACY_DOC_CONTRACT_SCHOOL_EDU": "<a href='https://privacy.smxstudio.it/mappe/smxstudio-mappe-contratto-scuole.pdf' target='_blank'>Contratto di servizi informatici per l'accesso alla piattaforma SMX studio modulo mappe per le scuole</a>",
  "PRIVACY_DOC_CONTRACT_UNIVERSITY_EDU": "<a href='https://privacy.smxstudio.it/mappe/smxstudio-mappe-contratto-universita.pdf' target='_blank'>Contratto di servizi informatici per l'accesso alla piattaforma SMX studio modulo mappe per le università</a>",
  "PRIVACY_DOC_CONTRACT_PRIVATE_LAB": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-contratto-privati.pdf' target='_blank'>Contratto di servizi informatici per l'accesso alla piattaforma SMX studio completo per i privati</a>",
  "PRIVACY_DOC_CONTRACT_SCHOOL_LAB": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-contratto-scuole.pdf' target='_blank'>Contratto di servizi informatici per l'accesso alla piattaforma SMX studio completo per le scuole</a>",
  "PRIVACY_DOC_CONTRACT_UNIVERSITY_LAB": "<a href='https://privacy.smxstudio.it/completo/smxstudio-completo-contratto-scuole.pdf' target='_blank'>Contratto di servizi informatici per l'accesso alla piattaforma SMX studio completo per le università</a>",
  "PRIVACY_DOC_TITLE": "Accettazione del Contratto e dei Termini di Servizio",
  "PRIVACY_ERROR": "Non è possibile proseguire se non si esprime il consenso al trattamento dei dati.",
  "PRIVACY_NEWSLETTER_CONFIRM": "Sì, desidero iscrivermi alla newsletter",
  "PRIVACY_NEWSLETTER_INFO": "<a href='' target='_blank'></a>Invio della newsletter informativa ed eventuali informazioni di tipo commerciale afferenti i servizi e prodotti Anastasis, attraverso apposite campagne online. L’invio di queste comunicazioni è riservato agli utenti che dichiarano di aver compiuto il 18° anno di età.<br>Per questa finalità chiediamo di prestare un consenso specifico che potrà sempre essere ritirato disiscrivendosi attraverso il link presente nelle comunicazioni ricevute o scrivendoci all’indirizzo mail: <a href='mailto:privacy@anastasis.it' target='_blank'>privacy@anastasis.it</a><br><br>Nel caso di consenso prestato da un minore, a norma degli artt. 2 quinquies d.lgs 196/2003 e 8 par 1 Reg.UE 679/2016, si rammenta che il consenso è validamente espresso solo se lo stesso minore abbia compiuto i 14 anni.<br>In caso contrario dovrà esservi la prestazione del consenso da parte del genitore o di chi ne fa le veci.<br><br>Per l’invio di tali comunicazioni viene utilizziamo Mailchimp, piattaforma che utilizza gli standard GDPR per la protezione dei dati.<br>Per maggiori informazioni: <a href='https://mailchimp.com/legal/privacy' target='_blank'>mailchimp.com/legal/privacy</a>",
  "QRCODE_TITLE_GDOC": "Scansiona per aprire il Documento Google",
  "QRCODE_TITLE_MAP": "Scansiona per aprire la mappa",
  "QUICKEDIT_TOOLBAR_MSG": "Inserimento rapido abilitato",
  "RACU_LINK": "https://www.anastasis.it/contatti/",
  "RACU_LINK_TEXT": "Servizio Clienti",
  "RACU_TEXT_01": "Questo tipo di abbonamento non può essere rinnovato con procedura automatica",
  "RACU_TEXT_02": "Puoi rinnovare la convenzione doposcuola",
  "RACU_TEXT_03": "oppure contattare il nostro",
  "RACU_TITLE": "Rinnovo del tuo abbonamento doposcuola",
  "RANGE_PAGE_LABEL_1": "0 di {{length}}",
  "RANGE_PAGE_LABEL_2": "{{page}} di {{length}}",
  "RCU_LINK": "https://www.anastasis.it/contatti/",
  "RCU_LINK_TEXT": "Servizio Clienti",
  "RCU_TEXT_01": "Questo tipo di abbonamento non può essere rinnovato con procedura automatica",
  "RCU_TEXT_02": "Per rinnovare contatta il nostro",
  "RCU_TITLE": "Rinnovo del tuo abbonamento",
  "READONLY_MAP": "Mappa in sola lettura",
  "READ_ONLY": "sola lettura",
  "READ_TITLE": "Leggi",
  "RECENT_COPY_PLUR": "copie",
  "RECENT_COPY_SING": "copia",
  "RECENT_MAPS": "Tutte le mappe",
  "RECENT_MENU_CREATECOPY": "Crea una copia",
  "RECENT_MENU_DOWNLOAD": "Scarica",
  "RECENT_MENU_REMOVE": "Rimuovi dai recenti",
  "RECENT_MENU_RENAME": "Rinomina",
  "RECENT_TOOLBAR_SHOW-LIST": "mostra lista",
  "RECENT_TOOLBAR_SHOW-PREVIEWS": "mostra anteprime",
  "RECENT_TOOLBAR_SORT-ALPHABETIC": "alfabetico",
  "RECENT_TOOLBAR_SORT-DATE": "per data",
  "RECENT_TOOLBAR_SORT": "Ordina",
  "RECENT_VIEW_PLUR": "viste",
  "RECENT_VIEW_SING": "vista",
  "RECVIDEO_BUTTON": "Registra Video",
  "REFORDERID_NEW": " (nuovo)",
  "REFORDERID_RENEW": " (rinnovato)",
  "REFORDERID_UPDATE": " (modificato)",
  "RELOAD_PAGE": "Prova a ricaricare la pagina",
  "RENAME_RECENT_MAP": "Rinomina",
  "REPORT_GEN": "Gen",
  "REPORT_FEB": "Feb",
  "REPORT_MAR": "Mar",
  "REPORT_APR": "Apr",
  "REPORT_MAG": "Mag",
  "REPORT_GIU": "Giu",
  "REPORT_LUG": "Lug",
  "REPORT_AGO": "Ago",
  "REPORT_SET": "Set",
  "REPORT_OTT": "Ott",
  "REPORT_NOV": "Nov",
  "REPORT_DIC": "Dic",
  "REPORT_ACTIVESTUDENTS": "I TUOI STUDENTI ATTIVI QUEST'ANNO",
  "REPORT_ADMIN_TITLE": "Statistiche amministratore",
  "REPORT_CLASSROOM": "Classroom",
  "REPORT_CLASSROOM_TITLE": "Statistiche classe",
  "REPORT_COPIES": "Copie",
  "REPORT_CREATEDMAPS1": "Hai creato",
  "REPORT_CREATEDMAPS2": "mappe",
  "REPORT_DETAIL": "Nel dettaglio",
  "REPORT_DONE": "Cosa hai fatto con le tue mappe",
  "REPORT_EXPORT": "Dalla mappa hai",
  "REPORT_FACEBOOK": "Facebook",
  "REPORT_GOOGLEDOCS1": "Creato",
  "REPORT_GOOGLEDOCS2": "Documenti di Google",
  "REPORT_GOTOREPORT": "Statistiche",
  "REPORT": "GRUPPI DI LAVORO",
  "REPORT_IMAGES": "Immagini",
  "REPORT_INSERT": "MAPPE",
  "REPORT_LINK": "come link",
  "REPORT_LINK_QRCODE": "link/QRcode",
  "REPORT_LINKS": "Link",
  "REPORT_NEWMAPS": "Nuove",
  "REPORT_NODES": "Nodi",
  "REPORT_OPENMAPS": "Aperte",
  "REPORT_PRINTS2": "Stampe",
  "REPORT_SHARES": "Condivisioni",
  "REPORT_SHARING": "Mappe condivise",
  "REPORT_SHOW2": "Presentazioni",
  "REPORT_SOCIALS": "Altre condivisioni",
  "REPORT_STATORDER1": "i tuoi",
  "REPORT_STATORDER2": "studenti hanno creato",
  "REPORT_STATORDER3": "mappe e ne hanno aperte",
  "REPORT_STATS": "Statistiche",
  "REPORT_STUDENTS": "Studenti",
  "REPORT_STUDENTWORKS": "IL LAVORO DEI TUOI STUDENTI",
  "REPORT_TABLES": "Tabelle",
  "REPORT_USER_TITLE": "Statistiche utente",
  "REPORT_VIDEOS": "Video",
  "REPORT_VIEWS": "Visualizzazioni",
  "REPORT_WORDS": "Parole",
  "RESTORE_MESSAGE": "La mappa è stata cancellata, vuoi ripristinarla?",
  "RESTORE": "Ripristina",
  "RESTORE_TITLE": "Ripristina mappa",
  "ROLE_ADMIN": "Amministratore",
  "ROLE_AID": "Operatore AID",
  "ROLE_ANASTASIS": "Operatore Anastasis",
  "ROLE_USER": "Utente",
  "ROTATE_LEFT": "Ruota a sinistra",
  "ROTATE_RIGHT": "Ruota a destra",
  "SAVE_TOOLTIP": "Le modifiche sono salvate automaticamente in Drive",
  "SAVING_OTHER": "Sta salvando",
  "SAVING": "Salvataggio in corso...",
  "SCHOOL_YEAR": "Anno scolastico",
  "SEARCH_CLEAR": "Cancella ricerca",
  "SEARCH_CLOSE": "Chiudi",
  "SEARCH_GOOGLE": "Cerca in Google",
  "SEARCH_GOOGLEIMG": "Cerca in Google immagini",
  "SEARCH_IMAGES": "Cerca immagini",
  "SEARCH_IN": "Cerca in",
  "SEARCH_IN_GOOGLE_IMAGE": "Cerca in Google immagini",
  "SEARCH_IN_MAP_PLACEHOLDER": "Cerca nella mappa",
  "SEARCH_IN_WIKIPEDIA": "Cerca su Wikipedia",
  "SEARCH_IN_YOUTUBE": "Cerca su Youtube",
  "SEARCH_MAGIC": "Cerca magico",
  "SEARCH_MAP_PLACEHOLDER": "Cerca mappa...",
  "SEARCH_ON_WEB": "Cerca nel web",
  "SEARCH_PLACEHOLDER": "Cerca...",
  "SEARCH_WIKIPEDIA": "Cerca in Wikipedia",
  "SEARCH_YOUTUBE": "Cerca su Youtube",
  "SELECT_FOLDER": "Seleziona una cartella",
  "SEND_MAIL": "Invia mail",
  "SHARED_EDIT": "Condivisione collaborativa",
  "SHARED_PUBLIC": "Condivisa pubblicamente",
  "SHARED_VIEW": "Condivisione in visualizzazione",
  "SHARE_LINK_COPY": "Copia negli appunti",
  "SHARE_LINK_EDIT": "Modifica",
  "SHARE_LINK_LINK": "LINK",
  "SHARE_LINK_NONE": "Con limitazioni",
  "SHARE_LINK_QRCODE": "QRcode",
  "SHARE_LINK_READONLY": "Visualizzazione",
  "SHARE_LINK_REMOVE": "Rimuovi accesso",
  "SHARE_LINK_SHARE_TYPE": "Impostazioni di condivisione pubblica",
  "SHARE_RECENT": "Condividi",
  "SHAREGROUP_FREQ": "Frequenti",
  "SHAREGROUP_GROUP": "Gruppo di lavoro",
  "SHAREMAP_ADD_USER": "Email da autorizzare",
  "SHAREMAP_PUBLIC": "Accesso pubblico",
  "SHAREMAP_OWNER": "Proprietario/a",
  "SHAREMAP_TITLE": "Condivisione mappa",
  "SHAREMAP_USER_ADD": "%username% ha condiviso con te la mappa \n<b>%mapname%</b>",
  "SHAREMAP_USER_DELETE": "%username% ha interrotto la condivisione della mappa \n<b>%mapname%</b>",
  "SHAREMAP_USERSLIST": "Persone con accesso",
  "SHAREMAP_WARNING_NOT_SHARED": "ATTENZIONE!\nQuesta mappa al momento non è condivisa con nessun altro.\nSe vuoi condividerla con altri ricorda di assegnare i diritti di condivisione.",
  "SHARING_MESSAGE_CANDO": "Puoi copiare il link e visualizzare il QRcode",
  "SHARING_MESSAGE_EDIT": "Se condividi la mappa, chiunque con il link può visualizzarla",
  "SHARING_MESSAGE_VIEW": "La mappa è solo in VISUALIZZAZIONE, non puoi condividere",
  "SHARING_STOPPED": "Condivisione pubblica interrotta",
  "SHOW_DISABLED": "La presentazione è attiva solo se il documento è stato salvato",
  "SHOWING": "Presentazione",
  "SHOW_STATS": "Mostra statistiche",
  "SHOW_TOOLBAR_NEXT": "Prossimo passo",
  "SHOW_TOOLBAR_PREV": "Passo precedente",
  "SIZE_TOOLBAR-BOTH": "Uguali",
  "SIZE_TOOLBAR-HEIGHT": "Adatta all'altezza",
  "SIZE_TOOLBAR-SIZE": "Ridimensiona",
  "SIZE_TOOLBAR-WIDTH": "Adatta alla larghezza",
  "SPEECHEDIT_TOOLBAR_MSG": "Inserimento vocale abilitato",
  "START_DATE": "Data di inizio",
  "STAT_ADDIMAGE": "Immagini",
  "STAT_ADDLINK": "Link",
  "STAT_ADDNODE": "Nodi",
  "STAT_ADDTABLE": "Tabelle",
  "STAT_ADDVIDEO": "Video",
  "STAT_COPYSHARED": "Copie mappe condivise",
  "STAT_NEWMAP": "Mappe",
  "STAT_OPENMAP": "Aperte",
  "STAT_SHARELINK": "Mappe condivise",
  "STAT_VIEWSHARED": "Visualizzazioni mappe condivise",
  "STAT_WORDS": "Parole",
  "STATS_MANAGEMENT": "Statistiche generali",
  "STATS_NO_RESULT": "La query non ha fornito risultati",
  "STOP_SHARING_MAP": "Interrompi condivisione pubblica",
  "STOP": "Stop",
  "SUBSCRIPTION": "Abbonamento",
  "SUBSCRIPTION_NOTES": "Note operatore",
  "SUBSCRIPTIONS_LIST": "Abbonamenti",
  "SUSPEND_SUBSCRIPTION": "Disattiva abbonamento",
  "TABLE_MAXCOLROW": "Numero compreso tra 2 e 10 ",
  "TABLE_TOOLBAR-ADD-COL-AFTER": "Inserisci colonna dopo",
  "TABLE_TOOLBAR-ADD-COL-BEFORE": "Inserisci colonna prima",
  "TABLE_TOOLBAR-ADD-ROW-ABOVE": "Inserisci riga sopra",
  "TABLE_TOOLBAR-ADD-ROW-BELOW": "Inserisci riga sotto",
  "TABLE_TOOLBAR-REMOVE-COL": "Elimina colonna",
  "TABLE_TOOLBAR-REMOVE-ROW": "Elimina riga",
  "TABLE_TOOLBAR-REMOVE-TABLE": "Elimina tabella",
  "TABLE_TOOLBAR-LOCK": "Blocca tabella",
  "TABLE_TOOLBAR-UNLOCK": "Sblocca tabella",
  "TABLE_WARNING_EXTENDED": "La tabella contiene {%r} righe e {%c} colonne. Confermi di volerla incollare?",
  "TABLE_WARNING_TOOBIG": "La tabella contiene {%r} righe e {%c} colonne ed è troppo grande per poter essere incollata. Vuoi incollarla come nodo singolo?",
  "TEST": "TEST",
  "TEXT_NO_MAPS": "Creane di nuove o apri quelle esistenti",
  "TITLE_COPY_MAP": "Copia della mappa",
  "TITLE_OPEN_MAP": "Apri mappa",
  "TITLE_RENAME_MAP": "Rinomina la mappa",
  "UPDATE": "Aggiornamento",
  "UPDATE_GOOGLE_DOC": "Aggiorna documento Google",
  "USERDESKTOP_TITLE": "Scrivania",
  "USER_EXPIRED": "L'abbonamento è scaduto",
  "USER_IS_ME": " (tu)",
  "USER_IS_NOT_OWNER": "La mappa è stata fatta da altri",
  "USER_IS_OWNER": "Sei l'autore di questa mappa",
  "USERS_LIST": "Lista utenti",
  "USERS_MANAGEMENT": "Gestione utenti",
  "USERS_DELETE": "Elimina utente",
  "USER_DELETED": "Utente eliminato:",
  "USER_DELETE_FAIL": "OOPS! Qualcosa è andato storto utente non cancellato:",
  "USER_DELETE_SHORT": "Scrivi almeno 3 caratteri per cercare gli utenti",
  "USERS_LIST_INCOMPLETE": "Lista utenti incompleta",
  "CONFIRM_USERS_DELETE": "Con questa operazione verrà rimosso l'utente da Firebase ed anche tutti i dati relativi. Sei sicuro di voler eliminare questo utente? ",
  "VERSION": "Versione",
  "VIEW_MODE": "Visualizza",
  "WAIT": "Attendi",
  "WARNING": "Attenzione",
  "WARNING_STOP_SHARING": "Eliminando la mappa dei recenti la condivisione sarà interrotta.",
  "WEBINAR": "Webinar",
  "WIKIPEDIA": "Wikipedia",
  "WRONG_PARAMS": "Alcuni parametri obbligatori mancanti",
  "YOUTUBE": "Youtube",
  "storageQuotaExceeded": "Google Drive non ha spazio sufficiente.",
  "insufficientFilePermissions": "L'utente non dispone di autorizzazioni sufficienti per il file",
  "access_denied": "Accesso negato",
  "INSERT_TEXT": "Inserisci testo",
  "CAPTURE": "Cattura immagine",
  "CAPTURE_INFO": "Trascina il mouse sugli appunti per ritagliare un'immagine",
  "CAPTURE_MATH": "Cattura formula matematica",
  "DRAW_TITLE": "Disegna",
  "VOICES": "Voci",
  "TITLE_BLOCKNOTES": "Appunti senza titolo",
  "DROP_PDF": "Trascina qui il PDF",
  "INSERT_LINK_PDF": "oppure inserisci il link o carica il file",
  "IMPORTS_PDF": "Carica PDF",
  "FROM_GD": "Da Google Drive",
  "FROM_LINK": "Da link",
  "CHANGE_COLOR": "Cambia colore",
  "OPEN_RECENT_MAP": "Apri recente",
  "OPEN": "Apri",
  "MY_PDF": "I miei PDF",
  "PDF_DELETE": "Elimina",
  "PDF_PLACEORDER": "Incolla qui il link del PDF",
  "CONFIRM_CLONE_POPUP": "Confermi la duplicazione dell'avviso?",
  "CONFIRM_DELETE_POPUP": "Confermi la cancellazione dell'avviso?",
  "CONFIRM_DELETE_PDF": "Confermi la cancellazione del documento?",
  "CONFIRM_RESTORE_PDF": "Il pdf è stato eliminato. Vuoi recuperarlo?",
  "CONFIRM_RELOAD_PDF": "Il PDF è stato modificato in un'altra sessione<br>e sarà aggiornato alla versione più recente.",
  "MATH_PRIMARY_KEYBOARD": "Primaria",
  "MATH_BASIC_KEYBOARD": "Base",
  "MATH_SETS_KEYBOARD": "Insiemistica",
  "MATH_GEOMETRY_KEYBOARD": "Geometria",
  "MATH_DISEQUATIONS_KEYBOARD": "Disequazioni",
  "MATH_PHYSICS_KEYBOARD": "Fisica",
  "MATH_ANALYSIS_KEYBOARD": "Analisi",
  "MATH_TRIGONOMETRY_KEYBOARD": "Trigonometria",
  "MATH_LOG_EXP_KEYBOARD": "Logaritmi ed Esponenziali",
  "MATH_GREEK_KEYBOARD": "αβγ",
  "PREF_TITLE_MATH_KEYBOARD": "Imposta tastiera matematica",
  "PREF_DESC_MATH_KEYBOARD_TYPE_BASIC": "Suite di tastiere per scrivere la matematica",
  "PREF_DESC_MATH_KEYBOARD_TYPE_PRIMARY": "Tastiera consigliata per SCUOLA PRIMARIA",
  "PREF_DESC_MATH_KEYBOARD_PREFS_1": "Puoi sempre cambiare questa impostazione dal",
  "PREF_DESC_MATH_KEYBOARD_PREFS_2": "menu File / Impostazioni / Mappa / Matematica",
  "PREF_MATH_KEYBOARD_TYPE_BASIC": "Avanzata",
  "PREF_MATH_KEYBOARD_TYPE_PRIMARY": "Base",
  "PREF_MATH_KEYBOARDS": "Tastiere",
  "PREF_DESC_MATH_KEYBOARDS": "Scegli quali tastiere matematiche abilitare quando inserisci una formula matematica in un nodo.",
  "COPY_LATEX": "Copia LaTeX",
  "COLOR": "Colore",
  "BORDER_COLOR": "Bordo",
  "BRUSH": "Pennello",
  "CIRCLE": "Cerchio",
  "LINE": "Linea",
  "CHECK": "Spunta",
  "CONFIGPDF": "Configurazione annotazioni",
  "OPACITY": "Opacità",
  "COPY_UNDERLINE": "Copia testo sottolineato",
  "COPY_HIGHLIGHT": "Copia testo evidenziato",
  "EXTRACT_PDF": "Estrai pagine",
  "PRINT_PDF": "Stampa PDF",
  "SIDEBAR_PDF": "Attiva/disattiva barra laterale",
  "VIEW_FIND_PDF": "Trova nel documento",
  "AUTOMATIC_ZOOM": "Zoom automatico",
  "ACTUAL_SIZE": "Dimensioni effettive",
  "PAGE_FIT": "Adatta alla pagina",
  "PAGE_WIDTH": "Larghezza pagina",
  "PASTE_IN_NOTEPAD": "Incolla negli Appunti",
  "COPY_ON_NOTEPAD_MSG": "Testo incollato negli appunti",
  "TOAST_CLOSE": "Chiudi",
  "INSERT_DEEP": "Inserisci in approfondimento",
  "COPY_ON_DEEP_MSG": "Testo incollato nell'approfondimento",
  "NO_NODE_SELECTED": "Selezionare un nodo",
  "INVALID_PDF": "Questo file non è un PDF valido",
  "INVALID_URL": "Questo link non è valido",
  "INVALID_HTML": "L'HTML che hai inserito nel campo di testo non è valido",
  "USER_PROFILE_TITLE": "Modifica profilo",
  "CREATE_PROFILE": "Il tuo profilo di SMX studio",
  "CREATE_PROFILE_BUTTON": "Crea profilo",
  "RESET_PASSWORD": "Reimposta Password",
  "FULLNAME": "Nome completo",
  "PASSWORD": "Password",
  "USERNAME": "Email utente",
  "CONFIRM_PASSWORD": "Conferma password",
  "CHOOSE_AVATAR": "Cambia foto",
  "DRIVE_QUOTA_EXCEEDED": "Lo spazio su Google Drive non è sufficiente. Prova a liberare spazio e riprova.",
  "AUTH_ERROR": "Credenziali non valide",
  "ACTIVE_ITEM_CREATION_LIMIT_EXCEEDED": "Questo account ha superato il limite di creazione di 500 milioni di elementi. Per creare più elementi, eliminare definitivamente alcuni elementi.",
  "DAILY_LIMIT_EXCEEDED": "Limite giornaliero superato",
  "FILE_OWNER_NOT_MEMEBER_OF_TEAM_DRIVE": "Impossibile spostare un file in un'unità condivisa come scrittore quando il proprietario del file non è un membro dell'unità condivisa.",
  "INSUFFICIENT_FILE_PERMISSIONS": "L'utente non dispone di autorizzazioni sufficienti per il file.",
  "DRIVE_HIERARCHY_DEPTH_LIMIT_EXCEEDED": "Il Drive personale non può contenere più di 100 livelli di cartelle.",
  "STORAGE_QUOTA_EXCEEDED": "La quota di archiviazione di Drive dell'utente è stata superata.",
  "TEAM_DRIVE_FILE_LIMIT_EXCEEDED": "Il limite di file per questo Drive condiviso è stato superato.",
  "TEAM_DRIVE_MEMBERSHIP_REQUIRED": "L'azione tentata richiede l'iscrizione al Drive condiviso.",
  "USER_RATE_LIMIT_EXCEEDED": "Superato il limite di frequenza dell'utente.",
  "DRIVE_QUOTA_EXCEEDED_MESSAGE_MAPVIEW": "La quota di archiviazione di Drive dell'utente è stata superata. Per modificare la mappa è necessario liberare spazio di archiviazione. Vuoi aprire la mappa in sola visualizzazione?",
  "ORDER_BY": "Ordinamento",
  "ALL_MAPS": "Tutte",
  "MY_MAPS": "Mie",
  "OTHERS_MAPS": "Di altri",
  "TRASH_BIN": "Cestino",
  "REMOVE_AVATAR": "Rimuovi foto",
  "LINK_WITH_GOOGLE": "Associa account Google",
  "DISCONNECT": "Disconnetti",
  "SIGNIN": "Registrati",
  "YOUR_EMAIL": "oppure accedi con la tua email",
  "FORGOT_PASSWORD": "Password dimenticata?",
  "PASSWORD_RECOVERY": "RECUPERO PASSWORD",
  "FORGOT_PASSWORD_MSG": "Inserisci qui sotto il tuo indirizzo email: ti invieremo subito le istruzioni da seguire",
  "SEND": "Invia",
  "REQUEST_RECOVERY_PASSWORD": "Richiesta recupero password",
  "RESPONSE_RP_1": "Ti abbiamo appena inviato una email all'indirizzo ",
  "RESPONSE_RP_2": "%email% contentente un link per impostare una nuova password.",
  "RESPONSE_RP_3": "Dovresti ricevere questa email entro alcuni secondi. Se così non fosse, verifica tra le tue email di Spam/Posta indesiderata.",
  "RESPONSE_RP_4": "In caso di necessità potrai anche contattare",
  "LINK_ASSISTANCE": "l'assistenza tecnica",
  "GO_TO_HOME": "Torna all'homepage",
  "REGISTER_MSG": "Controlleremo se possiedi già un account. In caso contrario, ti aiuteremo a crearne uno e attiveremo un periodo dimostrativo di 30 giorni, durante i quali avrai accesso a tutte le funzionalità di SMX studio",
  "GOON": "Continua",
  "OPEN_FROM_DRIVE": "Da Google Drive",
  "NO_DOCS_ALL": "NON SONO PRESENTI MAPPE INIZIA A CREARE!",
  "NO_DOCS_MINE": "NON SONO PRESENTI MAPPE",
  "NO_DOCS_OTHERS": "NESSUNA MAPPA CONDIVISA CON TE… PER ORA!",
  "NO_DOCS_TRASH": "IL CESTINO È VUOTO",
  "REQUEST_SIGNIN": "Primo accesso",
  "RESPONSE_RS_1": "Ti abbiamo appena inviato una email all'indirizzo ",
  "RESPONSE_RS_2": "%email% contentente un link per accedere a SMX studio.",
  "RESPONSE_RS_3": "Dovresti ricevere questa email entro alcuni secondi. Se così non fosse, verifica tra le tue email di Spam/Posta indesiderata.",
  "RESPONSE_RS_4": "In caso di necessità potrai anche contattare",
  "INSERT_PASSWORD": "Inserisci la password",
  "EDIT": "Modifica",
  "AVATAR": "Foto profilo",
  "EDIT_PROFILE": "Il tuo profilo",
  "REENTER_EMAIL": "Ti preghiamo di fornire la tua email per la conferma",
  "TTS_ENABLED_SPEECHSYNTHESIS_MESSAGE": "Sintesi vocale attivata",
  "TTS_SPEECHSYNTHESIS_ENABLE_REQUEST": "Vuoi abilitare la sintesi vocale?",
  "GOOGLE_SIGNIN_MESSAGE": "L'utente è già presente come utente Google. Clicca Ok ed entra con il contatto Google.",
  "HEADER_ABOUT_DEVICE": "Informazioni sul dispositivo",
  "EDIT_PASSWORD": "Modifica password",
  "SET_PASS1": "La nuova password deve rispettare questi criteri:",
  "SET_PASS2": "almeno 8 caratteri",
  "SET_PASS3": "almeno una lettera",
  "SET_PASS4": "almeno un numero o un carattere speciale",
  "SET_PASS5": "Fai attenzione a non inserire nella password riferimenti alla tua email o al tuo nome e cognome, facilmente individuabili.",
  "HINT_OLD_PASSWORD": "Inserisci la vecchia password",
  "HINT_NEW_PASSWORD": "Inserisci la nuova password",
  "HINT_REPEAT_PASSWORD": "Ripeti la password inserita",
  "ERR_SAVE_PASSWORD": "Si è verificato un errore durante il salvataggio.",
  "ERR_OLD_PASSWORD": "La vecchia password non è corretta.",
  "ERR_ONE_LETTER": "Attenzione! Deve contenere almeno una lettera.",
  "ERR_ONE_SYMBOL": "Attenzione! Deve contenere almeno un carattere speciale.",
  "ERR_LENGTH_PASSWORD": "Attenzione! La password deve essere di almeno 8 caratteri.",
  "ERR_SAME_PASSWORD": "Attenzione! la nuova password è uguale a quella attuale",
  "ERR_DIFFERENT_PASSWORD": "Attenzione! Le due password non coincidono.",
  "SAVE": "Salva",
  "UNKNOWN_USERNAME": "Utente ignoto",
  "EXPORT_IN_GOOGLE_DRIVE": "Esporta in Google Drive",
  "EXPORT_SUCCESS": "Esportazione effettuata con successo!",
  "PUBLIC_SHARE_LIMIT_ONLY_PERMISSION": "Con limitazioni",
  "PUBLIC_SHARE_LIMIT_ANYONE_WITH_LINK": "Chiunque abbia il link",
  "PUBLIC_SHARE_LIMIT_ONLY_PERMISSION_DESCRIPTION": "Solo le persone con accesso possono usare il link per aprire il documento",
  "PUBLIC_SHARE_VIEW_ONLY_PERMISSION_DESCRIPTION": "Tutte le persone che hanno il link possono visualizzare il documento",
  "PUBLIC_SHARE_EDIT_PERMISSION_DESCRIPTION": "Tutte le persone che hanno il link possono modificare il documento",
  "SHARE_COPY_LINK": "Copia link",
  "PREPARING_MAP": "Preparazione mappa per Classroom",
  "SHARE_SAVE_MESSAGE": "Condivisione aggiornata",
  "NOTIFICATIONS_FOOTER_BUTTON": "Mostra tutte le notifiche degli ultimi 30 giorni",
  "REMOVE_RECENT_MAP": "Rimuovi dall'elenco",
  "DELETE_RECENT_MAP": "Elimina definitivamente",
  "TRASH_RECENT_MAP": "Sposta nel cestino",
  "UNTRASH_RECENT_MAP": "Ripristina",
  "MSG_TRASHED_MAP": "La mappa è stata spostata nel cestino",
  "MSG_UNTRASHED_MAP": "La mappa è stata ripristinata",
  "MSG_REMOVED_MAP": "La mappa è stata rimossa dall'elenco",
  "MSG_DELETED_MAP": "La mappa è stata cancellata",
  "TRASH_WARNING": "Le mappe nel cestino verranno eliminate automaticamente dopo 90 giorni dalla cancellazione",
  "TRASH_EMPTY": "Svuota cestino",
  "TRASH_EMPTY_CONFIRM": "Confermi lo svuotamento del cestino?\nLe mappe cancellate non potranno più essere recuperate.",
  "TRASH_EMPTIED": "Il cestino è stato svuotato",
  "EXPIRED_WARNING_1": "Il tuo dimostrativo è scaduto in data ",
  "EXPIRED_WARNING_2": " Puoi continuare a vedere le mappe in sola lettura.",
  "MESS_GOOGLE_ACCOUNT_1": "Avendo effettuato l'accesso tramite Google con l'indirizzo email ",
  "MESS_GOOGLE_ACCOUNT_2": "SMX studio è connesso in automatico al tuo Google Drive.",
  "MESS_GOOGLE_ACCOUNT_3": "È possibile modificare i campi del profilo dal proprio account Google.",
  "TRASH_DELETE_CONFIRM": "Se confermi, la mappa sarà eliminata definitivamente.",
  "TRASH_RESTORE_OPEN_CONFIRM": "Vuoi ripristinare la mappa e aprirla?",
  "TRASH_REMOVE_CONFIRM": "Se confermi, la mappa sarà rimossa dalla tua lista e per riaprirla dovrai utilizzare il link fornito dall'autore.",
  "EXISTING_ACCOUNT": "Account già presente nella piattaforma",
  "NOTIFICATION_OPEN_TOOLTIP": "Apri",
  "SHARED_VIEW_MINE": "Mappa condivisa",
  "SHARED_EDIT_MINE": "Mappa condivisa",
  "SHARED_VIEW_OTHER_AUTHOR": "Mappa di",
  "SHARED_EDIT_OTHER_AUTHOR": "Mappa di",
  "PASSWORD_UPDATED": "Password modificata con successo",
  "CONTINUE_WITH_GOOGLE": "Continua con Google",
  "IMPORT_DESCRIPTION": "Scegli un file .sme dal tuo disco locale e importalo in SMX studio",
  "auth/too-many-requests": "L'accesso a questo account è stato temporaneamente disabilitato a causa di numerosi tentativi di accesso non riusciti. Puoi ripristinarlo immediatamente reimpostando la password oppure riprovare più tardi.",
  "auth/wrong-password": "Password errata",
  "MSG_BLOCKED_POPUP": "Sul tuo browser ci sono i popup bloccati, premi ok per aprire la mappa",
  "HOME_ERROR_GENERIC_MAP_UPLOAD": "Errore nel caricamento della mappa",
  "MAP_VIEW_VIEW_BUTTON": "Solo Visualizzazione",
  "MAP_VIEW_VIEW_BUTTON_MESSAGE": "Puoi solo visualizzare questa mappa. Crea una copia se vuoi modificarla",
  "DEEP_SHOW_IMAGE": "Mostra immagine",
  "DEEP_HIDE_IMAGE": "Nascondi immagine",
  "RICONNNECT_GOOGLE_ACCOUNT": "Attenzione. Prova a riconnettere il tuo account Google",
  "DELETE_ALL_DATA": "Cancella tutti i dati",
  "DESC_DELETE_DATA": "Salva il codice Utente! Se vuoi recuperare i documenti vai nella pagina dedicata (admin-move-docs) e quando l'utente avrà effettuato l'accesso, controlla il nuovo UID e copia i dati da quello vecchio a quello nuovo.",
  "CALCULATING": "Calcolo in corso...",
  "ERROR": "Errore",
  "SUBSCRIPTION_NEW": "Nuovo abbonamento",
  "SUBSCRIPTION_RENEW": "Rinnovo",
  "SELECT_SUBSCRIPTION_BUTTON": "Rinnova questo abbonamento",
  "SELECT_SUBSCRIPTION_TITLE": "Seleziona l'abbonamento da rinnovare",
  "SUBSCRIPTION_HEADER_EXPIRY": "Scadenza",
  "SUBSCRIPTION_HEADER_OWNER": "Proprietario",
  "SUBSCRIPTION_HEADER_NAME": "Nome Abbonamento",
  "SUBSCRIPTION_TBD_TITLE": "Assegna abbonamento",
  "SUBSCRIPTION_TBD_SUBTITLE": "Specifica se l'abbonamento che hai acquistato è un nuovo abbonamento o un rinnovo di un abbonamento precedente.",
  "PLANID_MAPS": "SMX studio - Modulo Mappe",
  "PLANID_FULL": "SMX studio - Completo",
  "ACTIVE": "Attivo",
  "TBD": "Da definire",
  "REDIRECT": "Rinnovo",
  "OLD_USER_EMAIL": "Email vecchia",
  "NEW_USER_EMAIL": "Email nuova",
  "ACCESSCONFIG_MANAGE_ACCESSES": "Gestione accessi",
  "DELETE_ACCESSES": "Elimina accessi",
  "DELETE_ACCESSES_CONFIRM": "Confermi l'eliminazione degli accessi per gli utenti selezionati?",
  "DELETE_ACCESSES_SUCCESS": "Accessi eliminati con successo",
  "DELETE_ACCESSES_ERROR": "Errore durante l'eliminazione degli accessi",
  "DELETE_ACCESSES_INFO_1": "NOTA: eliminare un accesso impedirà a quell'utente di accedere al sistema, a meno che non ci siano ancora licenze disponibili nel dominio.",
  "DELETE_ACCESSES_INFO_2": "L'operazione di cancellazione NON COMPORTA LA CANCELLAZIONE DEI DOCUMENTI UTENTE.",
  "USERACCESS_EMAIL": "Email",
  "USERACCESS_FULLNAME": "Nome completo",
  "USERACCESS_LASTACCESS": "Ultimo accesso",
  "USERACCESS_MAX_LICENSES": "Numero massimo di licenze",
  "USERACCESS_CURR_LICENSES": "Numero di licenze attive",
  "USERACCESS_LICENSES_LEFT": "Numero di licenze disponibili",
  "POPUP_MANAGEMENT": "Gestione avvisi",
  "POPUP_TITLE": "Titolo",
  "POPUP_TITLE_PLACEHOLDER": "Inserisci il titolo",
  "POPUP_CONTENT": "Contenuto",
  "POPUP_CONTENT_PLACEHOLDER": "Contenuto in html",
  "POPUP_CONTENT_HINT": "Usa questo tool",
  "POPUP_EMAILS": "Email",
  "POPUP_EMAILS_PLACEHOLDER": "Lista di email",
  "POPUP_EMAILS_HINT": "Lista di email separata da virgola",
  "POPUP_DOMAINS": "Dominio",
  "POPUP_DOMAINS_PLACEHOLDER": "Lista di domini",
  "POPUP_DOMAINS_HINT": "Lista di domini (es. @xxxxx.it) separata da virgola",
  "POPUP_TARGETS": "Tipo piano",
  "POPUP_TARGETS_HINT": "Seleziona il tipo piano a cui è rivolto l'avviso",
  "POPUP_LICENSE_TYPE": "Tipo licenza",
  "POPUP_LICENSE_TYPE_HINT": "Seleziona il tipo licenza a cui è rivolto l'avviso",
  "POPUP_LINK": "Link",
  "POPUP_IMAGE": "Immagine",
  "POPUP_IMAGE_PLACEHOLDER": "Inserisci l'immagine in base64",
  "POPUP_IMAGE_HINT": "L'immagine sarà ridimensionata automaticamente a 200px di altezza.",
  "POPUP_LINK_PLACEHOLDER": "Inserisci il link",
  "POPUP_START_DATE": "Data di pubblicazione",
  "POPUP_END_DATE": "Data di scadenza",
  "POPUP": "Avvisi",
  "POPUP_EDIT": "Modifica avviso",
  "POPUP_NEW": "Nuovo avviso",
  "NEW_POPUP": "Nuovo",
  "POPUP_PREVIEW": "Anteprima",
  "POPUP_CLONE": "Clone",
  "POPUP_TARGET": "Tipo abbonamento",
  "ADMINISTRATION": "Amministrazione",
  "USER_DESKTOP": "Scrivania utente",
  "FIND_MORE": "Scopri di piú",
  "full": "Completo",
  "maps": "Mappe",
  "all": "Tutti",
  "STATS_SCHOOL_YEAR": "Anno scolastico",
  "STATS_MONTH": "Singolo mese",
  "STATS_FREE_PERIOD": "Da mese a mese",
  "STATS_RUN_QUERY": "Esegui",
  "ACCESSCONFIG_AI_AVAILABLE_CREDITS": "Crediti AI disponibili",
  "USERS_MANAGE_ACCESS": {
    "USERS_MANAGE_USERS_TITLE": "Gestione utenti",
    "USERS_MANAGE_ACCESSES_TITLE": "Gestione accessi",
    "USERS_MANAGE_ADMINS_TITLE": "Amministratori",
    "ASSIGN_CREDITS_BUTTON": "Assegna crediti",
    "DELETE_ACCESS_BUTTON": "Elimina accessi",
    "SEND_MAIL_BUTTON": "Invia e-mail",
    "MAIL_COLUMN_NAME": "E-mail",
    "NAME_COLUMN_NAME": "Nome",
    "NOTES_COLUMN_NAME": "Note",
    "CLAIRE_TOGGLE_COLUMN_NAME": "Claire",
    "CLAIRE_CREDITS_COLUMN_NAME": "Crediti",
    "CLAIRE_USED_CREDITS_COLUMN_NAME": "Crediti usati",
    "LAST_ACCESS_COLUMN_NAME": "Ultimo accesso",
    "ACTIONS_COLUMN_NAME": "Azioni",
    "NO_DATA": "Nessun utente trovato",
    "ADD_USER_BUTTON": "Nuovo utente",
    "ADD_BUTTON": "Aggiungi",
    "ADD_USER_EMAIL_ERROR": "Indirizzo email non valido",
    "ADD_USER_NAME_ERROR": "Nome utente non valido",
    "ADD_USER_DUPLICATE_ERROR": "L'utente con email {{email}} è già presente."
  },
  "USER-CONFIG-FORM": {
    "DATA_SECTION": "Dati",
    "EMAIL_LABEL": "Email",
    "EMAIL_REQUIRED": "Email richiesta",
    "EMAIL_INVALID": "Indirizzo email non valido",
    "NAME_LABEL": "Nome",
    "NAME_REQUIRED": "Nome richiesto",
    "NOTES_LABEL": "Note",
    "CONFIRM_BUTTON": "Salva modifiche",
    "CANCEL_BUTTON": "Annulla",
    "CLAIRE_ACTIVE_LABEL": "Attiva Claire",
    "CLAIRE_LABEL": "Claire",
    "CLAIRE_CREDITS_LABEL": "Gestisci crediti",
    "CREDITS_POSITIVE": "I crediti non possono essere negativi",
    "CREDITS_MAX": "Crediti massimi non sufficienti",
    "ROLE_LABEL": "Ruolo",
    "ADMIN_ROLE": "Amministratore",
    "LAST_ACCESS_LABEL": "Ultimo accesso",
    "NO_LAST_ACCESS": "L'utente non ha mai effettuato un accesso.",
    "CLAIRE_AVAILABLE_CREDITS_LABEL": "Disponibili"
  },
  "ORDER_PAGINATOR": {
    "ITEMS_PER_PAGE": "Abbonamenti per pagina:",
    "NEXT_PAGE": "Pagina successiva",
    "PREVIOUS_PAGE": "Pagina precedente",
    "FIRST_PAGE": "Prima pagina",
    "LAST_PAGE": "Ultima pagina",
    "RANGE_PAGE_EMPTY": "0 di {{length}} abbonamenti",
    "NO_FILES": "Nessun abbonamento",
    "RANGE_PAGE_WITH_PAGES": "{{current}} di {{totalPages}} pagine ({{totalFiles}} abbonamenti)"
  },
  "USER_PAGINATOR": {
    "ITEMS_PER_PAGE": "Utenti per pagina:",
    "NEXT_PAGE": "Pagina successiva",
    "PREVIOUS_PAGE": "Pagina precedente",
    "FIRST_PAGE": "Prima pagina",
    "LAST_PAGE": "Ultima pagina",
    "RANGE_PAGE_EMPTY": "0 di {{length}} utenti",
    "NO_FILES": "Nessun utente",
    "RANGE_PAGE_WITH_PAGES": "{{current}} di {{totalPages}} pagine ({{totalFiles}} utenti)"
  },
  "DELETE_USER_ACCESS_DIALOG_TITLE": "Elimina Accesso",
  "DELETE_USER_ACCESS_DIALOG_BODY": "Sei sicuro di voler eliminare l'accesso di {{count}} utente/i?",
  "DELETE_USER_ACCESS_DIALOG_BODY_SEND_MAIL": "Vuoi inviare una mail agli utenti interessati per informarli dell'eliminazione del loro accesso?",
  "DELETE_USER_ACCESS_DIALOG_CONFIRM_BUTTON": "Elimina",
  "DELETE_USER_ACCESS_DIALOG_CANCEL_BUTTON": "Annulla",
  "DELETE_ADMIN_DIALOG_TITLE": "Elimina Amministratore",
  "DELETE_ADMIN_DIALOG_BODY": "Sei sicuro di voler eliminare {{count}} amministratore/i?",
  "DELETE_ADMIN_DIALOG_CONFIRM_BUTTON": "Elimina",
  "DELETE_ADMIN_DIALOG_CANCEL_BUTTON": "Annulla",
  "DELETE_USER_DIALOG_TITLE": "Elimina Utente",
  "DELETE_USER_DIALOG_BODY": "Sei sicuro di voler eliminare l'accesso di {{count}} utente/i?",
  "DELETE_USER_DIALOG_BODY_SEND_MAIL": "Vuoi inviare una mail agli utenti interessati per informarli dell'eliminazione dell'utente?",
  "DELETE_USER_DIALOG_CONFIRM_BUTTON": "Elimina",
  "DELETE_USER_DIALOG_CANCEL_BUTTON": "Annulla",
  "ADD_USER_ACCESS_DIALOG_TITLE": "Aggiungi Utente",
  "ADD_USER_ACCESS_DIALOG_BODY_SEND_MAIL": "Vuoi inviare una mail all'utente interessato per informarlo dell'accesso?",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_TITLE": "Assegna crediti Claire",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_BODY": "Inserisci il numero di crediti da assegnare a ciascun utente selezionato.",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_CONFIRM_BUTTON": "Assegna Crediti",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_CANCEL_BUTTON": "Annulla",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_INPUT_FIELD_LABEL": "Crediti per utente",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_INFO_SELECTED_USERS": "Utenti selezionati:",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_INFO_MAX_CREDITS": "Crediti massimi disponibili:",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_INFO_TOTAL_CREDITS": "Crediti totali richiesti:",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_INPUT_REQUIRED_ERROR": "Inserisci il numero di crediti da assegnare",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_INPUT_MIN_ERROR": "Il numero di crediti da assegnare deve essere maggiore di zero",
  "ASSIGN_CLAIRE_CREDITS_DIALOG_INPUT_LIMIT_ERROR": "Totale crediti {{totalCredits}} supera il limite massimo di {{maxCredits}}",
  "SEARCH": "Cerca",
  "ERROR_MESSAGE": {
    "ACCESS_CONFIG_GENERIC_ERROR": "Si è verificato un errore durante il caricamento. Prova a ricaricare la pagina.",
    "ACCESSCONFIG_SAVE_CONTRACT_FAIL_ACCEPT": "Errore nel salvataggio dell'accettazione del contratto.",
    "ACCESSCONFIG_MAIL_FAIL": "Errore nell'invio della mail.",
    "ACCESSCONFIG_DO_ACTIONS_FAIL": "Si è verificato un errore durante l'esecuzione dell'azione. Prova a ricaricare la pagina e riprovare."
  },
  "ACTIVATE_CLAIRE": "Attivazione Claire",
  "DEACTIVATE_CLAIRE": "Disattivazione Claire",
  "ACTIVATE_USER": "Attivazione Utente",
  "DEACTIVATE_USER": "Disattivazione Utente",
  "ADMIN": {
    "FILTER": {
      "ALL": "Tutti",
      "SINGLE": "Singolo",
      "MULTIPLE": "Multipla",
      "DOMAIN": "Dominio",
      "DEMO": "Demo"
    }
  },
  "CLAIRE_WARNING": {
    "ASSIGN_CREDITS": "Ricorda di assegnare crediti all'utente",
    "REVOKE_CREDITS": "I crediti assegnati all'utente saranno revocati"
  }
}